import {
    Box,
    FormControl,
    Grid,
    InputAdornment,
    InputLabel,
    MenuItem,
    Select,
    SelectChangeEvent,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    TextField,
    OutlinedInput,
    styled,
    IconButton,
    Typography
} from "@mui/material";
import * as React from "react";
import { useEffect, useState } from "react";
import { apiRequest } from "../../api/ApiCall";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
    initDonationObj,
    DonationTypeList,
    DonationBooleanTypeList,
    DonationStringTypeList,
    initDonationCommentTextFieldObj,
    initDonationReadOnlyObj,
    initDonationShowEditIconObj,
    initDonationShowIconObj,
} from "../../data/type";
import {
    setSaveStatus,
    setDeleteRequestErrorList
} from "../../features/longPageSlice";
import { setObjDonation } from "../../features/donationSlice";
import { useUserContext } from "../../user-provider";
import { useUtilityContext } from "../../utility-provider";
import { LOCAL_CONSTANT } from "../Const";
import { userLogging } from "../../utility/firestore";
import InputWithIcons from "../components/InputWithIcons";
import {
    setPermissionFunc,
    setPermissionAddBoolFunc
} from "../components/PermissionFunc";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import EditIcon from "@mui/icons-material/Edit";
import DeficiencyCommentRegistModal from "../components/DeficiencyCommentRegistModal";
import {
    chatBubbleErrorSx,
    chatBubbleErrorAddBoolSx,
    chatBubbleIconSx,
    editIconCircleSx,
    iconHover,
} from "../components/ChatBubbleAndEditIconStyle";
import {
    BGDisabledColor,
    BorderDefaultColor,
    BGChangeColor,
    BorderHoverColor,
    BorderFocusedColor,
    BorderErrorColor
} from "../../data/table";
import {
    changeTextColor,
    changeNoSubkeyBGColor,
    changeBorderColor
} from "../../data/tableFunc";

export interface resultDialogProps {
    props: {};
}

const table = {
    marginBottom: "20px",
};

const cellLabelStyle = {
    width: "100px",
    border: "none",
};

const bottomCellLabelStyle = {
    width: "100px",
    borderBottom: "solid 1px #bcbcbc",
};

const titleLabelStyle = {
    marginBottm: "20px",
};

const descriptionLabelStyle = {
    fontSize: "12px",
};

const tableHeaderLabelCell = {
    width: "5%",
    textAlign: "center",
    border: "none",
};

const tableHeaderCell = {
    width: "220px",
    textAlign: "center",
    border: "none",
};

const tableCell = {
    width: "220px",
    border: "none",
};

const inactiveSelectStyle = {
    textAlign: "center", //プルダウン値 有無を中央寄せ
    backgroundColor: BGDisabledColor,
};

//非活性のテキストフィールド(有効駐車場面積 坪)
const inactiveTextSx = (
    isUserType: boolean,
    objRrBranchLog: any,
    labelName: string
) => {
    return {
        "& .MuiInputBase-input.MuiFilledInput-input.Mui-disabled": {
            WebkitTextFillColor: changeTextColor(
                isUserType,
                objRrBranchLog,
                LOCAL_CONSTANT.NAVI.DONATION,
                labelName
            ),
        },
        "& .MuiFilledInput-input": {
            textAlign: "center", //入力した値を中央寄せ
            paddingTop: "17px",
            paddingBottom: "17px",
        },
        "& .MuiInputAdornment-root.MuiInputAdornment-positionStart.MuiInputAdornment-filled.MuiInputAdornment-sizeMedium":
        {
            marginTop: "0px",
        },
        "& .MuiInputBase-root.MuiFilledInput-root.Mui-disabled:before": {
            borderBottomStyle: "solid",
        },
        "& .Mui-disabled.MuiInputBase-root": {
            backgroundColor: BGDisabledColor,
            "&: hover": {
                backgroundColor: BGDisabledColor,
            },
        },
    };
};

// プルダウンスタイル
const selectStyle = (
    isUserType: boolean,
    objRrBranchLog: any,
    objRequestErrorList: any,
    listDeficiencyComment: any,
    labelName: string,
    value: any
) => {
    //テキストカラー
    const color = changeTextColor(
        isUserType,
        objRrBranchLog,
        LOCAL_CONSTANT.NAVI.DONATION,
        labelName
    );
    //背景
    const backgroundColor = changeNoSubkeyBGColor(
        isUserType,
        objRequestErrorList,
        LOCAL_CONSTANT.NAVI.DONATION,
        labelName,
        value
    );
    //枠線
    const hasBorderColor = changeBorderColor(
        listDeficiencyComment,
        LOCAL_CONSTANT.NAVI.DONATION,
        labelName
    );
    return {
        "& .MuiSelect-select": {
            color: color
        },
        "& .MuiSelect-select.MuiInputBase-input.MuiOutlinedInput-input.Mui-disabled": {
            WebkitTextFillColor: color
        },
        textAlign: "center",
        backgroundColor: backgroundColor,
        "& .MuiOutlinedInput-notchedOutline": {
            borderColor: hasBorderColor ? BorderErrorColor : BorderDefaultColor,
            borderWidth: hasBorderColor ? "3pt" : "1pt"                           //線の幅調整
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: hasBorderColor ? BorderErrorColor : BorderHoverColor,    //ホバー時
            borderWidth: hasBorderColor ? "3pt" : "1pt"                           //線の幅調整
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: hasBorderColor ? BorderErrorColor : BorderFocusedColor,  //フォーカス時
            borderWidth: hasBorderColor ? "3pt" : "2pt"                           //線の幅調整

        },
        "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
            borderColor: hasBorderColor ? BorderErrorColor : BorderDefaultColor,  //非活性時
            borderWidth: hasBorderColor ? "3pt" : "1pt"                           //線の幅調整
        }
    };
};

//アスタリスク
const RedAsterisk = styled("span")({
    color: "red",
    marginLeft: "4px",
    display: "flex",
    alignItems: "center",
});

const Donation: React.FC<resultDialogProps> = ({ props }) => {
    //Redux Storeからデータ取得
    const objDonation = useAppSelector((state) => state.donation.obj);
    const objPicture = useAppSelector((state) => state.picture);
    //ロングページオブジェクト 候補地NOと枝を取得
    const objLongPageParam = useAppSelector((state) => state.longPage.param);
    //ステータス管理sequenceとタスクIDを取得するため
    const objLocationBase = useAppSelector(
        (state) => state.longPage.locationBase
    );
    //パラメーターオブジェクト
    const objLongPageSaveStatus = useAppSelector(
        (state) => state.longPage.saveStatus
    );
    // 不備コメントリスト
    const listDeficiencyComment = useAppSelector(
        (state) => state.deficiencyComment
    );

    //寄付きページの項目値をReduxへ登録する前に保存
    const [donation, setDonation] = useState<DonationTypeList>(initDonationObj);
    //側道A列の非活性
    const [isSideWayA, setIsSideWayA] = useState<boolean>(false);
    //側道B列の非活性
    const [isSideWayB, setIsSideWayB] = useState<boolean>(false);
    //裏道の非活性
    const [isBackstreet, setBackstreet] = useState<boolean>(false);
    //コードマスタ
    const [commonYesnone, setCommonYesnone] = useState<any>(); //有無
    const [visibilityFactorSignPostList, setVisibilityFactorSignPostList] = useState<any>(); //サインポール
    const [selectRoad, setSelectRoad] = useState<any>(); //採用道路

    const dispatch = useAppDispatch();
    const [userType, setUserType] = useState("");
    const user = useUserContext();
    const utilityCtx = useUtilityContext();

    //不備コメントモーダル項目名
    const [columnNameStr, setColumnNameStr] = useState<string>("");
    //不備コメントモーダルラベル名
    const [labelNameStr, setLabelNameStr] = useState<string>("");
    //不備コメントモーダル開閉フラグ
    const [deficiencyComentModalFlag, setDeficiencyComentModalFlag] =
        useState(false);
    //アイコン全体の表示非表示のステータス
    const [donationShowIconsObj, setDonationShowIconsObj] =
        useState<DonationBooleanTypeList>(initDonationShowIconObj);
    //不備コメントモーダル内、TextFieldのコメント
    const [donationCommentTextFieldObj, setDonationCommentTextFieldObj] =
        useState<DonationStringTypeList>(initDonationCommentTextFieldObj);
    //項目値を編集可能にするステータスの型定義
    const [donationReadOnlyObj, setDonationReadOnlyObj] =
        useState<DonationBooleanTypeList>(initDonationReadOnlyObj);
    //表示色変更用BQログデータ
    const objRrBranchLog = useAppSelector(
        (state) => state.longPage.rrBranchLog
    );
    //入力チェックエラーリスト
    const objRequestErrorList = useAppSelector(
        (state) => state.longPage.requestErrorList
    );

    //インプット
    const handleIntOrDecimalInputChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
        labelName: string
    ) => {
        const targetValue = e.target.value;
        const donationValue = donation[labelName];

        const regexRange0To9 = /^(|0|[0-9])$/; //入力規則:整数 範囲:0～9
        const regexRange0To5 = /^(|0|[0-5])$/; //入力規則:整数 範囲:0～5
        const regexRange0To200 = /^(|0|200|1\d{2}|[1-9]?\d)$/; //入力規則:整数 範囲:0～200
        const regexRange0To99999 = /^(|0|[1-9][0-9]{0,4})$/; //入力規則:整数 範囲:0～99999
        const regexRange0To99Point9 =
            /^(|0|0\.|0\.[0-9]|[1-9][0-9]{0,1}(\.[0-9]{0,1})?|)$/; //入力規則:小数点数 範囲:0～99.9
        const regexRange0To999Point9 =
            /^(|0|0\.|0\.[0-9]|[1-9][0-9]{0,2}(\.[0-9]{0,1})?|)$/; //入力規則:小数点数 範囲:0～999.9
        const regexRange0TO9999Point99 =
            /^(|0|0\.|0\.0|0\.[0-9][0-9]?|[1-9][0-9]{0,3}(\.[0-9]{0,2})?)$/; //入力規則:小数点数 範囲:0～9999.99

        //入力規則:整数 範囲:0～9
        const regexRange0To9Label = [
            "driving_lane_positive_frontage", //走行車線 正 前面
            "driving_lane_positive_sideway_a", //走行車線 正 側道A
            "driving_lane_positive_sideway_b", //走行車線 正 側道B
            "driving_lane_positive_backstreet", //走行車線 正 裏道
            "driving_lane_opposite_frontage", //走行車線 反 前面
            "driving_lane_opposite_sideway_a", //走行車線 反 側道A
            "driving_lane_opposite_sideway_b", //走行車線 反 側道B
            "driving_lane_opposite_backstreet", //走行車線 反 裏道
        ];

        //入力規則:整数 範囲:0～5
        const regexRange0To5Label = [
            "visibility_factor_sign_post", //視界性 サインポール 前面
            "visibility_factor_sign_post2", //視界性 サインポール 側道A
            "visibility_factor_sign_post3", //視界性 サインポール 側道B
            "visibility_factor_sign_post4", //視界性 サインポール 裏道
        ];

        //入力規則:整数 範囲:0～200
        const regexRange0To200Label = [
            "traffic_signal_etc_forward_distance", //信号・踏切 先 距離 前面
            "traffic_signal_etc_forward_distance2", //信号・踏切 先 距離 側道A
            "traffic_signal_etc_forward_distance3", //信号・踏切 先 距離 側道B
            "traffic_signal_etc_forward_distance4", //信号・踏切 先 距離 裏道
            "traffic_signal_etc_front_location_distance", //信号・踏切 手前 距離 前面
            "traffic_signal_etc_front_location_distance2", //信号・踏切 手前 距離 側道A
            "traffic_signal_etc_front_location_distance3", //信号・踏切 手前 距離 側道B
            "traffic_signal_etc_front_location_distance4", //信号・踏切 手前 距離 裏道
        ];

        //入力規則:小数点数 範囲:0～99.9
        const regexRange0To99Point9Label = [
            "road_width_door", //車道幅員 ドア 前面
            "road_width_door2", //車道幅員 ドア 側道A
            "road_width_door3", //車道幅員 ドア 側道B
            "road_width_door4", //車道幅員 ドア 裏道
            "road_width_forward", //車道幅員 先 前面
            "road_width_forward2", //車道幅員 先 側道A
            "road_width_forward3", //車道幅員 先 側道B
            "road_width_forward4", //車道幅員 先 裏道
            "road_width_front_location", //車道幅員 手前 前面
            "road_width_front_location2", //車道幅員 手前 側道A
            "road_width_front_location3", //車道幅員 手前 側道B
            "road_width_front_location4", //車道幅員 手前 裏道
            "slope_climb", //坂道(長さ1m当たり) 登 前面
            "slope_climb2", //坂道(長さ1m当たり) 登 側道A
            "slope_climb3", //坂道(長さ1m当たり) 登 側道B
            "slope_climb4", //坂道(長さ1m当たり) 登 裏道
            "slope_descend", //坂道(長さ1m当たり) 降 前面
            "slope_descend2", //坂道(長さ1m当たり) 降 側道A
            "slope_descend3", //坂道(長さ1m当たり) 降 側道B
            "slope_descend4", //坂道(長さ1m当たり) 降 裏道
        ];

        //入力規則:小数点数 範囲:0～999.9
        const regexRange0To999Point9Label = [
            "median_strip_height", //中央分離帯 高さ 前面
            "median_strip_height2", //中央分離帯 高さ 側道A
            "median_strip_height3", //中央分離帯 高さ 側道B
            "median_strip_height4", //中央分離帯 高さ 裏道
            "sidewalk_height", //歩道 高さ 前面
            "sidewalk_height2", //歩道 高さ 側道A
            "sidewalk_height3", //歩道 高さ 側道B
            "sidewalk_height4", //歩道 高さ 裏道
            "visibility_factor_building", //視界性 建物 前面
            "visibility_factor_building2", //視界性 建物 側道A
            "visibility_factor_building3", //視界性 建物 側道B
            "visibility_factor_building4", //視界性 建物 裏道
            "parking_tangent_line_frontage", //駐車場接線 前面
            "parking_tangent_line_sideway_a", //駐車場接線 側道A
            "parking_tangent_line_sideway_b", //駐車場接線 側道B
            "parking_tangent_line_backstreet", //駐車場接線 裏道
            "no1_entrance_frontage", //出入口 No.1 進入口 前面
            "no1_entrance_sideway_a", //出入口 No.1 進入口 側道A
            "no1_entrance_sideway_b", //出入口 No.1 進入口 側道B
            "no1_entrance_backstreet", //出入口 No.1 進入口 裏道
            "no1_depth_frontage", //出入口 No.1 奥行き 前面
            "no1_depth_sideway_a", //出入口 No.1 奥行き 側道A
            "no1_depth_sideway_b", //出入口 No.1 奥行き 側道B
            "no1_depth_backstreet", //出入口 No.1 奥行き 裏道
            "no2_entrance_frontage", //出入口 No.2 進入口 前面
            "no2_entrance_sideway_a", //出入口 No.2 進入口 側道A
            "no2_entrance_sideway_b", //出入口 No.2 進入口 側道B
            "no2_entrance_backstreet", //出入口 No.2 進入口 裏道
            "no2_depth_frontage", //出入口 No.2 奥行き 前面
            "no2_depth_sideway_a", //出入口 No.2 奥行き 側道A
            "no2_depth_sideway_b", //出入口 No.2 奥行き 側道B
            "no2_depth_backstreet", //出入口 No.2 奥行き 裏道
        ];

        //入力規則:整数 範囲:0～99999
        const regexRange0To99999Label = [
            "parking_capacity" /* 有効駐車場面積 駐車可能台数 */,
        ];

        //入力規則:小数点数 範囲:0～9999.99
        const regexRange0TO9999Point99Label = [
            "parking_area" /* 有効駐車場面積 面積 ㎡ */,
        ];

        //入力判定
        if (regexRange0To9Label.includes(labelName)) {
            if (regexRange0To9.test(targetValue)) {
                setDonation({ ...donation, [labelName]: targetValue });
            } else {
                setDonation({ ...donation, [labelName]: donationValue });
            }
        } else if (regexRange0To5Label.includes(labelName)) {
            if (regexRange0To5.test(targetValue)) {
                setDonation({ ...donation, [labelName]: targetValue });
            } else {
                setDonation({ ...donation, [labelName]: donationValue });
            }
        } else if (regexRange0To200Label.includes(labelName)) {
            if (regexRange0To200.test(targetValue)) {
                setDonation({ ...donation, [labelName]: targetValue });
            } else {
                setDonation({ ...donation, [labelName]: donationValue });
            }
        } else if (regexRange0To99999Label.includes(labelName)) {
            if (regexRange0To99999.test(targetValue)) {
                setDonation({ ...donation, [labelName]: targetValue });
            } else {
                setDonation({ ...donation, [labelName]: donationValue });
            }
        } else if (regexRange0To99Point9Label.includes(labelName)) {
            if (regexRange0To99Point9.test(targetValue)) {
                setDonation({ ...donation, [labelName]: targetValue });
            } else {
                setDonation({ ...donation, [labelName]: donationValue });
            }
        } else if (regexRange0To999Point9Label.includes(labelName)) {
            if (regexRange0To999Point9.test(targetValue)) {
                setDonation({ ...donation, [labelName]: targetValue });
            } else {
                setDonation({ ...donation, [labelName]: donationValue });
            }
        } else if (regexRange0TO9999Point99Label.includes(labelName)) {
            if (regexRange0TO9999Point99.test(targetValue)) {
                setDonation({ ...donation, [labelName]: targetValue });
            } else {
                setDonation({ ...donation, [labelName]: donationValue });
            }
        }

        // 更新フラグ
        if (!objLongPageSaveStatus.Donation)
            dispatch(
                setSaveStatus({ ...objLongPageSaveStatus, Donation: true })
            );
    };

    //Redux プルダウン
    const handleSelectChange = (
        e: SelectChangeEvent<string>,
        labelName: string
    ) => {
        //プルダウンで無を選択した場合、その下の項目を空白に変更
        if (e.target.value === "0") {
            switch (labelName) {
                case "median_strip_select":
                    dispatch(setObjDonation({...objDonation, [labelName]: e.target.value, median_strip_height: ""}));
                    break;
                case "median_strip_select2":
                    dispatch(setObjDonation({...objDonation, [labelName]: e.target.value, median_strip_height2: ""}));
                    break;
                case "median_strip_select3":
                    dispatch(setObjDonation({...objDonation, [labelName]: e.target.value, median_strip_height3: ""}));
                    break;
                case "median_strip_select4":
                    dispatch(setObjDonation({...objDonation, [labelName]: e.target.value, median_strip_height4: ""}));
                    break;
                case "sidewalk_select":
                    dispatch(setObjDonation({...objDonation, [labelName]: e.target.value, sidewalk_height: ""}));
                    break;
                case "sidewalk_select2":
                    dispatch(setObjDonation({...objDonation, [labelName]: e.target.value, sidewalk_height2: ""}));
                    break;
                case "sidewalk_select3":
                    dispatch(setObjDonation({...objDonation, [labelName]: e.target.value, sidewalk_height3: ""}));
                    break;
                case "sidewalk_select4":
                    dispatch(setObjDonation({...objDonation, [labelName]: e.target.value, sidewalk_height4: ""}));
                    break;
                case "traffic_signal_etc_forward_select":
                    dispatch(setObjDonation({...objDonation, [labelName]: e.target.value, traffic_signal_etc_forward_distance: ""}));
                    break;
                case "traffic_signal_etc_forward_select2":
                    dispatch(setObjDonation({...objDonation,[labelName]: e.target.value, traffic_signal_etc_forward_distance2: ""}));
                    break;
                case "traffic_signal_etc_forward_select3":
                    dispatch(setObjDonation({...objDonation, [labelName]: e.target.value, traffic_signal_etc_forward_distance3: ""}));
                    break;
                case "traffic_signal_etc_forward_select4":
                    dispatch(setObjDonation({...objDonation, [labelName]: e.target.value, traffic_signal_etc_forward_distance4: ""}));
                    break;
                case "traffic_signal_etc_front_location_select":
                    dispatch(setObjDonation({...objDonation, [labelName]: e.target.value, traffic_signal_etc_front_location_distance: ""}));
                    break;
                case "traffic_signal_etc_front_location_select2":
                    dispatch(setObjDonation({...objDonation, [labelName]: e.target.value, traffic_signal_etc_front_location_distance2: ""}));
                    break;
                case "traffic_signal_etc_front_location_select3":
                    dispatch(setObjDonation({...objDonation, [labelName]: e.target.value, traffic_signal_etc_front_location_distance3: ""}));
                    break;
                case "traffic_signal_etc_front_location_select4":
                    dispatch(setObjDonation({...objDonation, [labelName]: e.target.value, traffic_signal_etc_front_location_distance4: ""}));
                    break;
                default:
                    dispatch(setObjDonation({...objDonation,[labelName]: e.target.value})); //プルダウンデータ更新
            } 
        } else {
            // プルダウンデータ更新
            dispatch(setObjDonation({ ...objDonation, [labelName]: e.target.value }));
        }
        // 更新フラグ
        if (!objLongPageSaveStatus.Donation)
            dispatch(setSaveStatus({ ...objLongPageSaveStatus, Donation: true }));
        //入力チェックのエラーリストから削除
        if (objRequestErrorList.length > 0)
            dispatch(setDeleteRequestErrorList({ page: LOCAL_CONSTANT.NAVI.DONATION, column: labelName }));
    };

    //Redux プルダウン
    const handleYearMonthSelectChange = (
        e: SelectChangeEvent<string>,
        labelName: string
    ) => {
        // プルダウンデータ更新 Redux Storeデータ変更
        dispatch(setObjDonation({ ...objDonation, [labelName]: e.target.value }));
        // 更新フラグ
        if (!objLongPageSaveStatus.Donation)
            dispatch(setSaveStatus({ ...objLongPageSaveStatus, Donation: true }));
        //入力チェックのエラーリストから削除
        if (objRequestErrorList.length > 0)
            dispatch(setDeleteRequestErrorList({ page: LOCAL_CONSTANT.NAVI.DONATION, column: labelName }));
    };
    
    //Redux 予測に採用した接道プルダウン
    const handleSelectRoadChange = (
        e: SelectChangeEvent<string>,
        labelName: string
    ) => {
        // プルダウンデータ更新 Redux Storeデータ変更
        dispatch(setObjDonation({ ...objDonation, [labelName]: e.target.value }));
        // 更新フラグ
        if (!objLongPageSaveStatus.Donation)
            dispatch(setSaveStatus({ ...objLongPageSaveStatus, Donation: true }));
    };

    //インプットをクリックしたときアイコンを表示
    const handleInputClick = (labelName: string) => {
        setDonationShowIconsObj({ ...donationShowIconsObj, [labelName]: true });
    };

    //吹き出しをクリックしたとき、モーダル画面を開く
    const handleChatBubbleClick = (labelName: string) => {
        setLabelNameStr(labelName);
        setDeficiencyComentModalFlag(true);
        setDonationCommentTextFieldObj({
            ...donationCommentTextFieldObj,
            [labelName]: "",
        }); //テキストフィールドのコメントを初期化
    };

    //鉛筆をクリックしたとき、Input編集可
    const handleEditIconClick = (labelName: string) => {
        if (
            setPermissionFunc(
                userType,
                objLocationBase.task_id,
                LOCAL_CONSTANT.NAVI.DONATION,
                labelName
            ) === false
        ) {
            //falseにすると、Input編集可
            setDonationReadOnlyObj({
                ...donationReadOnlyObj,
                [labelName]: false,
            });
        }
    };

    //不備コメントモーダル内でのコメント取得
    const handleCommentChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
        labelName: string
    ) => {
        setDonationCommentTextFieldObj({
            ...donationCommentTextFieldObj,
            [labelName]: e.target.value,
        });
    };

    //不備コメントモーダル内の保存ボタンをクリックしたときコメントを保存
    const handleSaveComment = async (labelName: string) => {
        //不備コメントを登録
        const params = {
            mode: "regist",
            endPoint: "/location/Deficiency/v1/regist",
            query: {
                plan_area_id: objLongPageParam.planAreaId,
                branch: objLongPageParam.branch,
                status_seq: objLocationBase.status_seq,
                table_name: LOCAL_CONSTANT.TABLE.DONATION,
                column_name: labelName,
                comment: donationCommentTextFieldObj[labelName],
                sub_key: LOCAL_CONSTANT.DEFICIENCY.DEFAULT_SUB_KEY
            },
        };
        userLogging(
            LOCAL_CONSTANT.FUNCTION_NAME.DONATION_COMMENT,
            params,
            user
        );
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner();
        }
        try {
            await apiRequest(params);
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
            //不備コメントモーダルを閉じる
            setDeficiencyComentModalFlag(false);
            //アイコンを非表示
            setDonationShowIconsObj({
                ...donationShowIconsObj,
                [labelName]: false,
            });
        } catch (e) {
            console.log(e);
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
            //不備コメントモーダルを閉じる
            setDeficiencyComentModalFlag(false);
            //アイコンを非表示
            setDonationShowIconsObj({
                ...donationShowIconsObj,
                [labelName]: false,
            });
        }

    };

    // インプットからフォーカスがずれたら、インプット編集不可とアイコンを非表示にする
    const handleInputBlur = (
        e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement, Element>,
        labelName: string
    ) => {
        //Reduxへ保存
        dispatch(setObjDonation({ ...donation, [labelName]: e.target.value }));

        //入力チェックのエラーリストから削除
        if (objRequestErrorList.length > 0)
            dispatch(setDeleteRequestErrorList({ page: LOCAL_CONSTANT.NAVI.DONATION, column: labelName }));

        // インプット編集不可
        setDonationReadOnlyObj({ ...donationReadOnlyObj, [labelName]: true });

        //インプットからフォーカスが移動する先がnullの場合アイコンを閉じる
        if (!e.relatedTarget) {
            setDonationShowIconsObj({
                ...donationShowIconsObj,
                [labelName]: false,
            });
        }

        //インプットからフォーカスが移動する先がインプットタグの場合アイコンを閉じる
        if (e.relatedTarget && e.relatedTarget.tagName === "INPUT") {
            setDonationShowIconsObj({
                ...donationShowIconsObj,
                [labelName]: false,
            });
        }
    };

    //コードマスタ取得
    useEffect(() => {
        const res: any = localStorage.getItem("codeMaster");
        if (res) {
            const d = JSON.parse(res);
            //コードマスタ
            setCommonYesnone(d["common_yesnone"]); //有無
            setVisibilityFactorSignPostList(d["visibility_factor_sign_post"]); //サインポール
            setSelectRoad(d["select_road"]); //採用道路
        }
    }, []);

    //ユーザー取得タイミングによる画面制御
    useEffect(() => {
        if (JSON.parse(user.userData || "null") !== null) {
            setUserType(JSON.parse(user.userData || "null").user_type);
        }
    }, [user]);

    useEffect(() => {
        //走行車線 正 反 の側道Aが「0」か「空」の場合 非活性
        if ((objDonation.driving_lane_positive_sideway_a === "0" || objDonation.driving_lane_positive_sideway_a === "") &&
            (objDonation.driving_lane_opposite_sideway_a === "0" || objDonation.driving_lane_opposite_sideway_a === "")
        ) {
            setIsSideWayA(true);
        } else {
            setIsSideWayA(false);
        }

        //走行車線 正 反 の側道Bが「0」か「空」の場合 非活性
        if ((objDonation.driving_lane_positive_sideway_b === "0" || objDonation.driving_lane_positive_sideway_b === "") &&
            (objDonation.driving_lane_opposite_sideway_b === "0" || objDonation.driving_lane_opposite_sideway_b === "")
        ) {
            setIsSideWayB(true);
        } else {
            setIsSideWayB(false);
        }

        //走行車線 正 反 の裏道が「0」か「空」の場合 非活性
        if ((objDonation.driving_lane_positive_backstreet === "0" || objDonation.driving_lane_positive_backstreet === "") &&
            (objDonation.driving_lane_opposite_backstreet === "0" || objDonation.driving_lane_opposite_backstreet === "")
        ) {
            setBackstreet(true);
        } else {
            setBackstreet(false);
        }
    }, [
        objDonation.driving_lane_positive_sideway_a,
        objDonation.driving_lane_opposite_sideway_a,
        objDonation.driving_lane_positive_sideway_b,
        objDonation.driving_lane_opposite_sideway_b,
        objDonation.driving_lane_positive_backstreet,
        objDonation.driving_lane_opposite_backstreet,
    ]);

    useEffect(() => {
        //ReduxをuseStateに保存
        setDonation(objDonation);
    }, [objDonation]);

    //不備コメントモーダルを閉じたときに、吹き出しと鉛筆アイコンを非表示
    useEffect(() => {
        if (!deficiencyComentModalFlag) {
            setDonationShowIconsObj({
                ...initDonationShowIconObj
            });
        }
    }, [deficiencyComentModalFlag]);

    useEffect(() => {
        const res: any = localStorage.getItem("codeMaster");
        const viewingDistance = Number(objPicture.viewing_distance);
        let setList: any = [];
        if(res){
            const d = JSON.parse(res);
            const VisibilityFactorSignPost = d["visibility_factor_sign_post"];
            if(viewingDistance < 50) {
                VisibilityFactorSignPost.map((row:any) => {
                    if(row.code_value === "0") {
                        setList.push(row);
                    }
                })
            } else if(50 <= viewingDistance && viewingDistance < 75) {
                VisibilityFactorSignPost.map((row:any) => {
                    if(row.code_value === "0" || row.code_value === "1") {
                        setList.push(row);
                    }
                })
            } else if(75 <= viewingDistance && viewingDistance < 100) {
                VisibilityFactorSignPost.map((row:any) => {
                    if(row.code_value === "0" || row.code_value === "1" || row.code_value === "2"){
                        setList.push(row);
                    }
                })
            } else if(100 <= viewingDistance && viewingDistance < 125) {
                VisibilityFactorSignPost.map((row:any) => {
                    if(row.code_value === "0" || row.code_value === "1" || 
                    row.code_value === "2" || row.code_value === "3") {
                        setList.push(row);
                    }
                })
            } else if(125 <= viewingDistance && viewingDistance < 150) {
                VisibilityFactorSignPost.map((row:any) => {
                    if(row.code_value === "0" || row.code_value === "1" || 
                    row.code_value === "2" || row.code_value === "3" || row.code_value === "4") {
                        setList.push(row);
                    }
                })
            } else if(viewingDistance == 150){
                VisibilityFactorSignPost.map((row:any) => {
                    setList.push(row);
                })
            }
            setVisibilityFactorSignPostList(setList);
        }
    },[objPicture]);

    return (
        <div style={{ width: "100%", margin: "30px" }}>
            <Grid container spacing={1} maxWidth="lg">
                <Grid item xs={12}>
                    <Table sx={table}>
                        <TableBody>
                            <TableRow>
                                <TableCell sx={tableHeaderLabelCell}></TableCell>
                                <TableCell sx={tableHeaderLabelCell}></TableCell>
                                <TableCell sx={tableHeaderCell}></TableCell>
                                <TableCell sx={tableHeaderCell}></TableCell>
                                {/* <TableCell sx={tableHeaderCell}>予測に採用した接道</TableCell> */}
                                <TableCell sx={{width: '220px', border: 'none'}}>
                                    <Typography>予測に採用した接道</Typography>
                                    <Typography sx={{fontSize: '0.68rem', paddingTop: '5px'}}>※側B・裏道いずれか一つのみを採用</Typography>
                                </TableCell>
                                <TableCell sx={tableHeaderCell}>
                                    <FormControl fullWidth>
                                        <Select
                                            onChange={(e) => handleSelectRoadChange(e, "select_road")}
                                            value={objDonation.select_road}
                                            sx={{
                                                backgroundColor: setPermissionFunc(
                                                    userType,
                                                    objLocationBase.task_id,
                                                    LOCAL_CONSTANT.NAVI.DONATION,
                                                    "select_road"
                                                ) ? BGDisabledColor : BGChangeColor, // trueならグレー、falseなら白
                                            }}
                                            disabled={setPermissionFunc(
                                                userType,
                                                objLocationBase.task_id,
                                                LOCAL_CONSTANT.NAVI.DONATION,
                                                "select_road"
                                            )}
                                        >
                                            <MenuItem value="">　</MenuItem>
                                            {selectRoad?.map(
                                                (row: any) => (
                                                    <MenuItem key={row.code_value} value={row.code_value}>
                                                        {row.code_display}
                                                    </MenuItem>
                                                )
                                            )}
                                        </Select>
                                    </FormControl>
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell sx={tableHeaderLabelCell}></TableCell>
                                <TableCell sx={tableHeaderLabelCell}></TableCell>
                                <TableCell sx={tableHeaderCell}>
                                    <InputLabel>{LOCAL_CONSTANT.LABEL.FRONT}</InputLabel>
                                </TableCell>
                                <TableCell sx={tableHeaderCell}>
                                    <InputLabel>{LOCAL_CONSTANT.LABEL.SIDE_A}</InputLabel>
                                </TableCell>
                                <TableCell sx={tableHeaderCell}>
                                    <InputLabel>{LOCAL_CONSTANT.LABEL.SIDE_B}</InputLabel>
                                </TableCell>
                                <TableCell sx={tableHeaderCell}>
                                    <InputLabel>{LOCAL_CONSTANT.LABEL.BACK}</InputLabel>
                                </TableCell>
                            </TableRow>

                            {/* 走行車線 正*/}
                            <TableRow>
                                <TableCell sx={cellLabelStyle} rowSpan={2}>
                                    <Grid container rowSpacing={2}>
                                        <Grid item xs={12}>
                                            <InputLabel sx={titleLabelStyle}>走行車線</InputLabel>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <InputLabel sx={descriptionLabelStyle}>右左折専用車線は含めず</InputLabel>
                                        </Grid>
                                    </Grid>
                                </TableCell>
                                <TableCell sx={cellLabelStyle}>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            width: "65px",
                                        }}
                                    >
                                        <InputLabel>正</InputLabel>
                                        <RedAsterisk>＊</RedAsterisk>
                                    </Box>
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    <InputWithIcons
                                        props={{
                                            userType: userType, //ユーザー
                                            disabled: setPermissionFunc(
                                                userType,
                                                objLocationBase.task_id,
                                                LOCAL_CONSTANT.NAVI.DONATION,
                                                "driving_lane_positive_frontage"
                                            ), //ユーザー権限
                                            pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                            labelName: "driving_lane_positive_frontage",
                                            startAdornment: "",
                                            endAdornment: LOCAL_CONSTANT.LABEL.LANE,
                                            InputValueObj: donation,
                                            ReadOnlyObj: donationReadOnlyObj,
                                            setReadOnlyObj: setDonationReadOnlyObj,
                                            ShowEditIconObj:initDonationShowEditIconObj,
                                            ShowIconsObj: donationShowIconsObj,
                                            handleChatBubbleClick:handleChatBubbleClick,
                                            handleInputBlur: handleInputBlur,
                                            handleInputChange:handleIntOrDecimalInputChange,
                                            handleInputClick: handleInputClick,
                                        }}
                                    />
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    <InputWithIcons
                                        props={{
                                            userType: userType, //ユーザー
                                            disabled: setPermissionFunc(
                                                userType,
                                                objLocationBase.task_id,
                                                LOCAL_CONSTANT.NAVI.DONATION,
                                                "driving_lane_positive_sideway_a"
                                            ), //ユーザー権限
                                            pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                            labelName: "driving_lane_positive_sideway_a",
                                            startAdornment: "",
                                            endAdornment: LOCAL_CONSTANT.LABEL.LANE,
                                            InputValueObj: donation,
                                            ReadOnlyObj: donationReadOnlyObj,
                                            setReadOnlyObj: setDonationReadOnlyObj,
                                            ShowEditIconObj: initDonationShowEditIconObj,
                                            ShowIconsObj: donationShowIconsObj,
                                            handleChatBubbleClick: handleChatBubbleClick,
                                            handleInputBlur: handleInputBlur,
                                            handleInputChange: handleIntOrDecimalInputChange,
                                            handleInputClick: handleInputClick,
                                        }}
                                    />
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    <InputWithIcons
                                        props={{
                                            userType: userType, //ユーザー
                                            disabled: setPermissionFunc(
                                                userType,
                                                objLocationBase.task_id,
                                                LOCAL_CONSTANT.NAVI.DONATION,
                                                "driving_lane_positive_sideway_b"
                                            ), //ユーザー権限
                                            pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                            labelName: "driving_lane_positive_sideway_b",
                                            startAdornment: "",
                                            endAdornment: LOCAL_CONSTANT.LABEL.LANE,
                                            InputValueObj: donation,
                                            ReadOnlyObj: donationReadOnlyObj,
                                            setReadOnlyObj: setDonationReadOnlyObj,
                                            ShowEditIconObj:initDonationShowEditIconObj,
                                            ShowIconsObj: donationShowIconsObj,
                                            handleChatBubbleClick: handleChatBubbleClick,
                                            handleInputBlur: handleInputBlur,
                                            handleInputChange: handleIntOrDecimalInputChange,
                                            handleInputClick: handleInputClick,
                                        }}
                                    />
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    <InputWithIcons
                                        props={{
                                            userType: userType, //ユーザー
                                            disabled: setPermissionFunc(
                                                userType,
                                                objLocationBase.task_id,
                                                LOCAL_CONSTANT.NAVI.DONATION,
                                                "driving_lane_positive_backstreet"
                                            ), //ユーザー権限
                                            pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                            labelName: "driving_lane_positive_backstreet",
                                            startAdornment: "",
                                            endAdornment: LOCAL_CONSTANT.LABEL.LANE,
                                            InputValueObj: donation,
                                            ReadOnlyObj: donationReadOnlyObj,
                                            setReadOnlyObj: setDonationReadOnlyObj,
                                            ShowEditIconObj: initDonationShowEditIconObj,
                                            ShowIconsObj: donationShowIconsObj,
                                            handleChatBubbleClick: handleChatBubbleClick,
                                            handleInputBlur: handleInputBlur,
                                            handleInputChange: handleIntOrDecimalInputChange,
                                            handleInputClick: handleInputClick,
                                        }}
                                    />
                                </TableCell>
                            </TableRow>

                            {/* 走行車線 反 */}
                            <TableRow sx={bottomCellLabelStyle}>
                                <TableCell sx={cellLabelStyle}>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            width: "65px",
                                        }}
                                    >
                                        <InputLabel>反</InputLabel>
                                        <RedAsterisk>＊</RedAsterisk>
                                    </Box>
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    <InputWithIcons
                                        props={{
                                            userType: userType, //ユーザー
                                            disabled: setPermissionFunc(
                                                userType,
                                                objLocationBase.task_id,
                                                LOCAL_CONSTANT.NAVI.DONATION,
                                                "driving_lane_opposite_frontage"
                                            ), //ユーザー権限
                                            pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                            labelName: "driving_lane_opposite_frontage",
                                            startAdornment: "",
                                            endAdornment: LOCAL_CONSTANT.LABEL.LANE,
                                            InputValueObj: donation,
                                            ReadOnlyObj: donationReadOnlyObj,
                                            setReadOnlyObj: setDonationReadOnlyObj,
                                            ShowEditIconObj: initDonationShowEditIconObj,
                                            ShowIconsObj: donationShowIconsObj,
                                            handleChatBubbleClick: handleChatBubbleClick,
                                            handleInputBlur: handleInputBlur,
                                            handleInputChange: handleIntOrDecimalInputChange,
                                            handleInputClick: handleInputClick,
                                        }}
                                    />
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    <InputWithIcons
                                        props={{
                                            userType: userType, //ユーザー
                                            disabled: setPermissionFunc(
                                                userType,
                                                objLocationBase.task_id,
                                                LOCAL_CONSTANT.NAVI.DONATION,
                                                "driving_lane_opposite_sideway_a"
                                            ), //ユーザー権限
                                            pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                            labelName: "driving_lane_opposite_sideway_a",
                                            startAdornment: "",
                                            endAdornment: LOCAL_CONSTANT.LABEL.LANE,
                                            InputValueObj: donation,
                                            ReadOnlyObj: donationReadOnlyObj,
                                            setReadOnlyObj: setDonationReadOnlyObj,
                                            ShowEditIconObj: initDonationShowEditIconObj,
                                            ShowIconsObj: donationShowIconsObj,
                                            handleChatBubbleClick: handleChatBubbleClick,
                                            handleInputBlur: handleInputBlur,
                                            handleInputChange: handleIntOrDecimalInputChange,
                                            handleInputClick: handleInputClick,
                                        }}
                                    />
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    <InputWithIcons
                                        props={{
                                            userType: userType, //ユーザー
                                            disabled: setPermissionFunc(
                                                userType,
                                                objLocationBase.task_id,
                                                LOCAL_CONSTANT.NAVI.DONATION,
                                                "driving_lane_opposite_sideway_b"
                                            ), //ユーザー権限
                                            pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                            labelName: "driving_lane_opposite_sideway_b",
                                            startAdornment: "",
                                            endAdornment: LOCAL_CONSTANT.LABEL.LANE,
                                            InputValueObj: donation,
                                            ReadOnlyObj: donationReadOnlyObj,
                                            setReadOnlyObj: setDonationReadOnlyObj,
                                            ShowEditIconObj: initDonationShowEditIconObj,
                                            ShowIconsObj: donationShowIconsObj,
                                            handleChatBubbleClick: handleChatBubbleClick,
                                            handleInputBlur: handleInputBlur,
                                            handleInputChange: handleIntOrDecimalInputChange,
                                            handleInputClick: handleInputClick,
                                        }}
                                    />
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    <InputWithIcons
                                        props={{
                                            userType: userType, //ユーザー
                                            disabled: setPermissionFunc(
                                                userType,
                                                objLocationBase.task_id,
                                                LOCAL_CONSTANT.NAVI.DONATION,
                                                "driving_lane_opposite_backstreet"
                                            ), //ユーザー権限
                                            pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                            labelName: "driving_lane_opposite_backstreet",
                                            startAdornment: "",
                                            endAdornment: LOCAL_CONSTANT.LABEL.LANE,
                                            InputValueObj: donation,
                                            ReadOnlyObj: donationReadOnlyObj,
                                            setReadOnlyObj: setDonationReadOnlyObj,
                                            ShowEditIconObj: initDonationShowEditIconObj,
                                            ShowIconsObj: donationShowIconsObj,
                                            handleChatBubbleClick: handleChatBubbleClick,
                                            handleInputBlur: handleInputBlur,
                                            handleInputChange:handleIntOrDecimalInputChange,
                                            handleInputClick: handleInputClick,
                                        }}
                                    />
                                </TableCell>
                            </TableRow>

                            {/* 中央分離帯 有無 */}
                            <TableRow>
                                <TableCell sx={cellLabelStyle} rowSpan={2}>
                                    <Grid container rowSpacing={2}>
                                        <Grid item xs={12}>
                                            <InputLabel sx={titleLabelStyle}>中央分離帯</InputLabel>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <InputLabel sx={descriptionLabelStyle}>ガードレール・植栽高さ等を含む</InputLabel>
                                        </Grid>
                                    </Grid>
                                </TableCell>
                                <TableCell sx={cellLabelStyle}>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            width: "65px",
                                        }}
                                    >
                                        <InputLabel>有無</InputLabel>
                                        <RedAsterisk>＊</RedAsterisk>
                                    </Box>
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    <Box sx={{ display: "flex" }}>
                                        <FormControl fullWidth>
                                            <Select
                                                onChange={(e) => handleSelectChange(e, "median_strip_select")}
                                                value={objDonation.median_strip_select}
                                                sx={selectStyle(
                                                    userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                        ? setPermissionFunc(
                                                            userType,
                                                            objLocationBase.task_id,
                                                            LOCAL_CONSTANT.NAVI.DONATION,
                                                            "median_strip_select"
                                                        )
                                                        : donationReadOnlyObj.median_strip_select,
                                                    objRrBranchLog,
                                                    objRequestErrorList,
                                                    listDeficiencyComment,
                                                    "median_strip_select",
                                                    objDonation.median_strip_select
                                                )}
                                                disabled={
                                                    userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                        ? setPermissionFunc(
                                                            userType,
                                                            objLocationBase.task_id,
                                                            LOCAL_CONSTANT.NAVI.DONATION,
                                                            "median_strip_select"
                                                        )
                                                        : donationReadOnlyObj.median_strip_select
                                                }
                                            >
                                                {commonYesnone?.map(
                                                    (row: any) => (
                                                        <MenuItem key={row.code_value} value={row.code_value}>
                                                            {row.code_display}
                                                        </MenuItem>
                                                    )
                                                )}
                                            </Select>
                                        </FormControl>
                                        {/* RFCの場合、不備コメント 吹き出しアイコンを表示 */}
                                        {/* RRの場合、不備コメント 吹き出しと編集アイコンを表示 */}
                                        {LOCAL_CONSTANT.USER_TYPE.RFC_RR.includes(userType) && (
                                            <Grid sx={{ display: "flex" }}>
                                                <IconButton
                                                    disabled={setPermissionFunc(
                                                        userType,
                                                        objLocationBase.task_id,
                                                        LOCAL_CONSTANT.NAVI.DONATION,
                                                        "median_strip_select"
                                                    )}
                                                    onClick={() => {handleChatBubbleClick("median_strip_select");}}
                                                    sx={iconHover}
                                                >
                                                    <Box
                                                        sx={chatBubbleErrorSx(
                                                            userType,
                                                            objLocationBase.task_id,
                                                            LOCAL_CONSTANT.NAVI.DONATION,
                                                            "median_strip_select",
                                                            listDeficiencyComment
                                                        )}
                                                    >
                                                        <ChatBubbleIcon sx={chatBubbleIconSx}/>
                                                    </Box>
                                                </IconButton>
                                                {userType === LOCAL_CONSTANT.USER_TYPE.RR && (
                                                    <IconButton
                                                        onClick={() => {handleEditIconClick("median_strip_select");}}
                                                        sx={iconHover}
                                                    >
                                                        <Box sx={editIconCircleSx}><EditIcon /></Box>
                                                    </IconButton>
                                                )}
                                            </Grid>
                                        )}
                                    </Box>
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    <Box sx={{ display: "flex" }}>
                                        {isSideWayA === true && (
                                            <FormControl fullWidth>
                                                <Select
                                                    value={objDonation.median_strip_select2}
                                                    sx={inactiveSelectStyle}
                                                    disabled={true}
                                                >
                                                    {commonYesnone?.map(
                                                        (row: any) => (
                                                            <MenuItem key={row.code_value} value={row.code_value}>
                                                                {row.code_display}
                                                            </MenuItem>
                                                        )
                                                    )}
                                                </Select>
                                            </FormControl>
                                        )}
                                        {isSideWayA === false && (
                                            <FormControl fullWidth>
                                                <Select
                                                    onChange={(e) => handleSelectChange(e, "median_strip_select2")}
                                                    value={objDonation.median_strip_select2}
                                                    sx={selectStyle(
                                                        userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                            ? setPermissionFunc(
                                                                userType,
                                                                objLocationBase.task_id,
                                                                LOCAL_CONSTANT.NAVI.DONATION,
                                                                "median_strip_select2"
                                                            )
                                                            : donationReadOnlyObj.median_strip_select2,
                                                        objRrBranchLog,
                                                        objRequestErrorList,
                                                        listDeficiencyComment,
                                                        "median_strip_select2",
                                                        objDonation.median_strip_select2
                                                    )}
                                                    disabled={
                                                        userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                            ? setPermissionFunc(
                                                                userType,
                                                                objLocationBase.task_id,
                                                                LOCAL_CONSTANT.NAVI.DONATION,
                                                                "median_strip_select2"
                                                            )
                                                            : donationReadOnlyObj.median_strip_select2
                                                    }
                                                >
                                                    {commonYesnone?.map(
                                                        (row: any) => (
                                                            <MenuItem key={row.code_value} value={row.code_value}>
                                                                {row.code_display}
                                                            </MenuItem>
                                                        )
                                                    )}
                                                </Select>
                                            </FormControl>
                                        )}
                                        {/* RFCの場合、不備コメント 吹き出しアイコンを表示 */}
                                        {/* RRの場合、不備コメント 吹き出しと編集アイコンを表示 */}
                                        {LOCAL_CONSTANT.USER_TYPE.RFC_RR.includes(userType) && (
                                            <Grid sx={{ display: "flex" }}>
                                                <IconButton
                                                    disabled={setPermissionAddBoolFunc(
                                                        isSideWayA,
                                                        userType,
                                                        objLocationBase.task_id,
                                                        LOCAL_CONSTANT.NAVI.DONATION,
                                                        "median_strip_select2"
                                                    )}
                                                    onClick={() => {handleChatBubbleClick("median_strip_select2");}}
                                                    sx={iconHover}
                                                >
                                                    <Box
                                                        sx={chatBubbleErrorAddBoolSx(
                                                            isSideWayA,
                                                            userType,
                                                            objLocationBase.task_id,
                                                            LOCAL_CONSTANT.NAVI.DONATION,
                                                            "median_strip_select2",
                                                            listDeficiencyComment
                                                        )}
                                                    >
                                                        <ChatBubbleIcon sx={chatBubbleIconSx}/>
                                                    </Box>
                                                </IconButton>
                                                {userType === LOCAL_CONSTANT.USER_TYPE.RR && (
                                                    <IconButton
                                                        disabled={isSideWayA}
                                                        onClick={() => {handleEditIconClick("median_strip_select2");}}
                                                        sx={iconHover}
                                                    >
                                                        <Box sx={editIconCircleSx}><EditIcon /></Box>
                                                    </IconButton>
                                                )}
                                            </Grid>
                                        )}
                                    </Box>
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    <Box sx={{ display: "flex" }}>
                                        {isSideWayB === true && (
                                            <FormControl fullWidth>
                                                <Select
                                                    onChange={(e) => handleSelectChange(e, "median_strip_select3")}
                                                    value={objDonation.median_strip_select3}
                                                    sx={inactiveSelectStyle}
                                                    disabled={true}
                                                >
                                                    {commonYesnone?.map(
                                                        (row: any) => (
                                                            <MenuItem key={row.code_value} value={row.code_value}>
                                                                {row.code_display}
                                                            </MenuItem>
                                                        )
                                                    )}
                                                </Select>
                                            </FormControl>
                                        )}
                                        {isSideWayB === false && (
                                            <FormControl fullWidth>
                                                <Select
                                                    onChange={(e) => handleSelectChange(e, "median_strip_select3")}
                                                    value={objDonation.median_strip_select3}
                                                    sx={selectStyle(
                                                        userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                            ? setPermissionFunc(
                                                                userType,
                                                                objLocationBase.task_id,
                                                                LOCAL_CONSTANT.NAVI.DONATION,
                                                                "median_strip_select3"
                                                            )
                                                            : donationReadOnlyObj.median_strip_select3,
                                                        objRrBranchLog,
                                                        objRequestErrorList,
                                                        listDeficiencyComment,
                                                        "median_strip_select3",
                                                        objDonation.median_strip_select3
                                                    )}
                                                    disabled={
                                                        userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                            ? setPermissionFunc(
                                                                userType,
                                                                objLocationBase.task_id,
                                                                LOCAL_CONSTANT.NAVI.DONATION,
                                                                "median_strip_select3"
                                                            )
                                                            : donationReadOnlyObj.median_strip_select3
                                                    }
                                                >
                                                    {commonYesnone?.map(
                                                        (row: any) => (
                                                            <MenuItem key={row.code_value} value={row.code_value}>
                                                                {row.code_display}
                                                            </MenuItem>
                                                        )
                                                    )}
                                                </Select>
                                            </FormControl>
                                        )}
                                        {/* RFCの場合、不備コメント 吹き出しアイコンを表示 */}
                                        {/* RRの場合、不備コメント 吹き出しと編集アイコンを表示 */}
                                        {LOCAL_CONSTANT.USER_TYPE.RFC_RR.includes(userType) && (
                                            <Grid sx={{ display: "flex" }}>
                                                <IconButton
                                                    disabled={setPermissionAddBoolFunc(
                                                        isSideWayB,
                                                        userType,
                                                        objLocationBase.task_id,
                                                        LOCAL_CONSTANT.NAVI.DONATION,
                                                        "median_strip_select3"
                                                    )}
                                                    onClick={() => {handleChatBubbleClick("median_strip_select3");}}
                                                    sx={iconHover}
                                                >
                                                    <Box
                                                        sx={chatBubbleErrorAddBoolSx(
                                                            isSideWayB,
                                                            userType,
                                                            objLocationBase.task_id,
                                                            LOCAL_CONSTANT.NAVI.DONATION,
                                                            "median_strip_select3",
                                                            listDeficiencyComment
                                                        )}
                                                    >
                                                        <ChatBubbleIcon sx={chatBubbleIconSx}/>
                                                    </Box>
                                                </IconButton>
                                                {userType === LOCAL_CONSTANT.USER_TYPE.RR && (
                                                    <IconButton
                                                        disabled={isSideWayB}
                                                        onClick={() => {handleEditIconClick("median_strip_select3");}}
                                                        sx={iconHover}
                                                    >
                                                        <Box sx={editIconCircleSx}><EditIcon /></Box>
                                                    </IconButton>
                                                )}
                                            </Grid>
                                        )}
                                    </Box>
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    <Box sx={{ display: "flex" }}>
                                        {isBackstreet === true && (
                                            <FormControl fullWidth>
                                                <Select
                                                    onChange={(e) => handleSelectChange(e, "median_strip_select4")}
                                                    value={objDonation.median_strip_select4}
                                                    sx={inactiveSelectStyle}
                                                    disabled={true}
                                                >
                                                    {commonYesnone?.map(
                                                        (row: any) => (
                                                            <MenuItem key={row.code_value} value={row.code_value}>
                                                                {row.code_display}
                                                            </MenuItem>
                                                        )
                                                    )}
                                                </Select>
                                            </FormControl>
                                        )}
                                        {isBackstreet === false && (
                                            <FormControl fullWidth>
                                                <Select
                                                    onChange={(e) => handleSelectChange(e, "median_strip_select4")}
                                                    value={objDonation.median_strip_select4}
                                                    sx={selectStyle(
                                                        userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                            ? setPermissionFunc(
                                                                userType,
                                                                objLocationBase.task_id,
                                                                LOCAL_CONSTANT.NAVI.DONATION,
                                                                "median_strip_select4"
                                                            )
                                                            : donationReadOnlyObj.median_strip_select4,
                                                        objRrBranchLog,
                                                        objRequestErrorList,
                                                        listDeficiencyComment,
                                                        "median_strip_select4",
                                                        objDonation.median_strip_select4
                                                    )}
                                                    disabled={
                                                        userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                            ? setPermissionFunc(
                                                                userType,
                                                                objLocationBase.task_id,
                                                                LOCAL_CONSTANT.NAVI.DONATION,
                                                                "median_strip_select4"
                                                            )
                                                            : donationReadOnlyObj.median_strip_select4
                                                    }
                                                >
                                                    {commonYesnone?.map(
                                                        (row: any) => (
                                                            <MenuItem key={row.code_value} value={row.code_value}>
                                                                {row.code_display}
                                                            </MenuItem>
                                                        )
                                                    )}
                                                </Select>
                                            </FormControl>
                                        )}
                                        {/* RFCの場合、不備コメント 吹き出しアイコンを表示 */}
                                        {/* RRの場合、不備コメント 吹き出しと編集アイコンを表示 */}
                                        {LOCAL_CONSTANT.USER_TYPE.RFC_RR.includes(userType) && (
                                            <Grid sx={{ display: "flex" }}>
                                                <IconButton
                                                    disabled={setPermissionAddBoolFunc(
                                                        isBackstreet,
                                                        userType,
                                                        objLocationBase.task_id,
                                                        LOCAL_CONSTANT.NAVI.DONATION,
                                                        "median_strip_select4"   
                                                    )}
                                                    onClick={() => {handleChatBubbleClick("median_strip_select4");}}
                                                    sx={iconHover}
                                                >
                                                    <Box
                                                        sx={chatBubbleErrorAddBoolSx(
                                                            isBackstreet,
                                                            userType,
                                                            objLocationBase.task_id,
                                                            LOCAL_CONSTANT.NAVI.DONATION,
                                                            "median_strip_select4",
                                                            listDeficiencyComment
                                                        )}
                                                    >
                                                        <ChatBubbleIcon sx={chatBubbleIconSx}/>
                                                    </Box>
                                                </IconButton>
                                                {userType === LOCAL_CONSTANT.USER_TYPE.RR && (
                                                    <IconButton
                                                        disabled={isBackstreet}
                                                        onClick={() => {handleEditIconClick("median_strip_select4");}}
                                                        sx={iconHover}
                                                    >
                                                        <Box sx={editIconCircleSx}><EditIcon /></Box>
                                                    </IconButton>
                                                )}
                                            </Grid>
                                        )}
                                    </Box>
                                </TableCell>
                            </TableRow>

                            {/* 中央分離帯 高さ */}
                            <TableRow sx={bottomCellLabelStyle}>
                                <TableCell sx={cellLabelStyle}>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            width: "65px",
                                        }}
                                    >
                                        <InputLabel>高さ</InputLabel>
                                        <RedAsterisk>＊＊</RedAsterisk>
                                    </Box>
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    <InputWithIcons
                                        props={{
                                            userType: userType, //ユーザー
                                            disabled: !(
                                                !setPermissionFunc(
                                                    userType,
                                                    objLocationBase.task_id,
                                                    LOCAL_CONSTANT.NAVI.DONATION,
                                                    "median_strip_height"
                                                ) &&
                                                objDonation.median_strip_select === "1"
                                            ), //ユーザー権限
                                            pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                            labelName: "median_strip_height",
                                            startAdornment: "",
                                            endAdornment: "cm",
                                            InputValueObj: donation,
                                            ReadOnlyObj: donationReadOnlyObj,
                                            setReadOnlyObj: setDonationReadOnlyObj,
                                            ShowEditIconObj: initDonationShowEditIconObj,
                                            ShowIconsObj: donationShowIconsObj,
                                            handleChatBubbleClick: handleChatBubbleClick,
                                            handleInputBlur: handleInputBlur,
                                            handleInputChange: handleIntOrDecimalInputChange,
                                            handleInputClick: handleInputClick,
                                        }}
                                    />
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    {isSideWayA === true && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: true, //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "median_strip_height2",
                                                startAdornment: "",
                                                endAdornment: "cm",
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                    {isSideWayA === false && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: !(
                                                    !setPermissionFunc(
                                                        userType,
                                                        objLocationBase.task_id,
                                                        LOCAL_CONSTANT.NAVI.DONATION,
                                                        "median_strip_height2"
                                                    ) && objDonation.median_strip_select2 === "1"
                                                ), //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "median_strip_height2",
                                                startAdornment: "",
                                                endAdornment: "cm",
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    {isSideWayB === true && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: true, //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "median_strip_height3",
                                                startAdornment: "",
                                                endAdornment: "cm",
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                    {isSideWayB === false && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: !(
                                                    !setPermissionFunc(
                                                        userType,
                                                        objLocationBase.task_id,
                                                        LOCAL_CONSTANT.NAVI.DONATION,
                                                        "median_strip_height3"
                                                    ) && objDonation.median_strip_select3 === "1"
                                                ), //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "median_strip_height3",
                                                startAdornment: "",
                                                endAdornment: "cm",
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    {isBackstreet === true && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: true, //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "median_strip_height4",
                                                startAdornment: "",
                                                endAdornment: "cm",
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                    {isBackstreet === false && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: !(
                                                    !setPermissionFunc(
                                                        userType,
                                                        objLocationBase.task_id,
                                                        LOCAL_CONSTANT.NAVI.DONATION,
                                                        "median_strip_height4"
                                                    ) && objDonation.median_strip_select4 === "1"
                                                ), //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "median_strip_height4",
                                                startAdornment: "",
                                                endAdornment: "cm",
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                </TableCell>
                            </TableRow>

                            {/* 歩道 有無*/}
                            <TableRow>
                                <TableCell sx={cellLabelStyle} rowSpan={2}>
                                    <Grid container rowSpacing={2}>
                                        <Grid item xs={12}>
                                            <InputLabel sx={titleLabelStyle}>歩道</InputLabel>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <InputLabel sx={descriptionLabelStyle}>ガードレール・植栽高さ等を含む</InputLabel>
                                        </Grid>
                                    </Grid>
                                </TableCell>
                                <TableCell sx={cellLabelStyle}>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            width: "65px",
                                        }}
                                    >
                                        <InputLabel>有無</InputLabel>
                                        <RedAsterisk>＊</RedAsterisk>
                                    </Box>
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    <Box sx={{ display: "flex" }}>
                                        <FormControl fullWidth>
                                            <Select
                                                onChange={(e) => handleSelectChange(e, "sidewalk_select")}
                                                value={objDonation.sidewalk_select}
                                                sx={selectStyle(
                                                    userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                        ? setPermissionFunc(
                                                            userType,
                                                            objLocationBase.task_id,
                                                            LOCAL_CONSTANT.NAVI.DONATION,
                                                            "sidewalk_select"
                                                        )
                                                        : donationReadOnlyObj.sidewalk_select,
                                                    objRrBranchLog,
                                                    objRequestErrorList,
                                                    listDeficiencyComment,
                                                    "sidewalk_select",
                                                    objDonation.sidewalk_select
                                                )}
                                                disabled={
                                                    userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                        ? setPermissionFunc(
                                                            userType,
                                                            objLocationBase.task_id,
                                                            LOCAL_CONSTANT.NAVI.DONATION,
                                                            "sidewalk_select"
                                                        )
                                                        : donationReadOnlyObj.sidewalk_select
                                                }
                                            >
                                                {commonYesnone?.map(
                                                    (row: any) => (
                                                        <MenuItem key={row.code_value} value={row.code_value}>
                                                            {row.code_display}
                                                        </MenuItem>
                                                    )
                                                )}
                                            </Select>
                                        </FormControl>
                                        {/* RFCの場合、不備コメント 吹き出しアイコンを表示 */}
                                        {/* RRの場合、不備コメント 吹き出しと編集アイコンを表示 */}
                                        {LOCAL_CONSTANT.USER_TYPE.RFC_RR.includes(userType) && (
                                            <Grid sx={{ display: "flex" }}>
                                                <IconButton
                                                    disabled={setPermissionFunc(
                                                        userType,
                                                        objLocationBase.task_id,
                                                        LOCAL_CONSTANT.NAVI.DONATION,
                                                        "sidewalk_select"
                                                    )}
                                                    onClick={() => {handleChatBubbleClick("sidewalk_select");}}
                                                    sx={iconHover}
                                                >
                                                    <Box
                                                        sx={chatBubbleErrorSx(
                                                            userType,
                                                            objLocationBase.task_id,
                                                            LOCAL_CONSTANT.NAVI.DONATION,
                                                            "sidewalk_select",
                                                            listDeficiencyComment
                                                        )}
                                                    >
                                                        <ChatBubbleIcon sx={chatBubbleIconSx}/>
                                                    </Box>
                                                </IconButton>
                                                {userType === LOCAL_CONSTANT.USER_TYPE.RR && (
                                                    <IconButton
                                                        onClick={() => {handleEditIconClick("sidewalk_select");}}
                                                        sx={iconHover}
                                                    >
                                                        <Box sx={editIconCircleSx}><EditIcon /></Box>
                                                    </IconButton>
                                                )}
                                            </Grid>
                                        )}
                                    </Box>
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    <Box sx={{ display: "flex" }}>
                                        {isSideWayA === true && (
                                            <FormControl fullWidth>
                                                <Select
                                                    onChange={(e) => handleSelectChange(e, "sidewalk_select2")}
                                                    value={objDonation.sidewalk_select2}
                                                    sx={inactiveSelectStyle}
                                                    disabled={true}
                                                >
                                                    {commonYesnone?.map(
                                                        (row: any) => (
                                                            <MenuItem key={row.code_value} value={row.code_value}>
                                                                {row.code_display}
                                                            </MenuItem>
                                                        )
                                                    )}
                                                </Select>
                                            </FormControl>
                                        )}
                                        {isSideWayA === false && (
                                            <FormControl fullWidth>
                                                <Select
                                                    onChange={(e) => handleSelectChange(e, "sidewalk_select2")}
                                                    value={objDonation.sidewalk_select2}
                                                    sx={selectStyle(
                                                        userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                            ? setPermissionFunc(
                                                                userType,
                                                                objLocationBase.task_id,
                                                                LOCAL_CONSTANT.NAVI.DONATION,
                                                                "sidewalk_select2"
                                                            )
                                                            : donationReadOnlyObj.sidewalk_select2,
                                                        objRrBranchLog,
                                                        objRequestErrorList,
                                                        listDeficiencyComment,
                                                        "sidewalk_select2",
                                                        objDonation.sidewalk_select2
                                                    )}
                                                    disabled={
                                                        userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                            ? setPermissionFunc(
                                                                userType,
                                                                objLocationBase.task_id,
                                                                LOCAL_CONSTANT.NAVI.DONATION,
                                                                "sidewalk_select2"
                                                            )
                                                            : donationReadOnlyObj.sidewalk_select2
                                                    }
                                                >
                                                    {commonYesnone?.map(
                                                        (row: any) => (
                                                            <MenuItem key={row.code_value} value={row.code_value}>
                                                                {row.code_display}
                                                            </MenuItem>
                                                        )
                                                    )}
                                                </Select>
                                            </FormControl>
                                        )}
                                        {/* RFCの場合、不備コメント 吹き出しアイコンを表示 */}
                                        {/* RRの場合、不備コメント 吹き出しと編集アイコンを表示 */}
                                        {LOCAL_CONSTANT.USER_TYPE.RFC_RR.includes(userType) && (
                                            <Grid sx={{ display: "flex" }}>
                                                <IconButton
                                                    disabled={
                                                        setPermissionAddBoolFunc(
                                                            isSideWayA,
                                                            userType,
                                                            objLocationBase.task_id,
                                                            LOCAL_CONSTANT.NAVI.DONATION,
                                                            "sidewalk_select2"
                                                        )}
                                                    onClick={() => {handleChatBubbleClick("sidewalk_select2");}}
                                                    sx={iconHover}
                                                >
                                                    <Box
                                                        sx={chatBubbleErrorAddBoolSx(
                                                            isSideWayA,
                                                            userType,
                                                            objLocationBase.task_id,
                                                            LOCAL_CONSTANT.NAVI.DONATION,
                                                            "sidewalk_select2",
                                                            listDeficiencyComment
                                                        )}
                                                    >
                                                        <ChatBubbleIcon sx={chatBubbleIconSx}/>
                                                    </Box>
                                                </IconButton>
                                                {userType === LOCAL_CONSTANT.USER_TYPE.RR && (
                                                    <IconButton
                                                        disabled={isSideWayA}
                                                        onClick={() => {handleEditIconClick("sidewalk_select2");}}
                                                        sx={iconHover}
                                                    >
                                                        <Box sx={editIconCircleSx}><EditIcon /></Box>
                                                    </IconButton>
                                                )}
                                            </Grid>
                                        )}
                                    </Box>
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    <Box sx={{ display: "flex" }}>
                                        {isSideWayB === true && (
                                            <FormControl fullWidth>
                                                <Select
                                                    onChange={(e) => handleSelectChange(e, "sidewalk_select3")}
                                                    value={objDonation.sidewalk_select3}
                                                    sx={inactiveSelectStyle}
                                                    disabled={true}
                                                >
                                                    {commonYesnone?.map(
                                                        (row: any) => (
                                                            <MenuItem key={row.code_value} value={row.code_value}>
                                                                {row.code_display}
                                                            </MenuItem>
                                                        )
                                                    )}
                                                </Select>
                                            </FormControl>
                                        )}
                                        {isSideWayB === false && (
                                            <FormControl fullWidth>
                                                <Select
                                                    onChange={(e) => handleSelectChange(e, "sidewalk_select3")}
                                                    value={objDonation.sidewalk_select3}
                                                    sx={selectStyle(
                                                        userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                            ? setPermissionFunc(
                                                                userType,
                                                                objLocationBase.task_id,
                                                                LOCAL_CONSTANT.NAVI.DONATION,
                                                                "sidewalk_select3"
                                                            )
                                                            : donationReadOnlyObj.sidewalk_select3,
                                                        objRrBranchLog,
                                                        objRequestErrorList,
                                                        listDeficiencyComment,
                                                        "sidewalk_select3",
                                                        objDonation.sidewalk_select3
                                                    )}
                                                    disabled={
                                                        userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                            ? setPermissionFunc(
                                                                userType,
                                                                objLocationBase.task_id,
                                                                LOCAL_CONSTANT.NAVI.DONATION,
                                                                "sidewalk_select3"
                                                            )
                                                            : donationReadOnlyObj.sidewalk_select3
                                                    }
                                                >
                                                    {commonYesnone?.map(
                                                        (row: any) => (
                                                            <MenuItem key={row.code_value} value={row.code_value}>
                                                                {row.code_display}
                                                            </MenuItem>
                                                        )
                                                    )}
                                                </Select>
                                            </FormControl>
                                        )}
                                        {/* RFCの場合、不備コメント 吹き出しアイコンを表示 */}
                                        {/* RRの場合、不備コメント 吹き出しと編集アイコンを表示 */}
                                        {LOCAL_CONSTANT.USER_TYPE.RFC_RR.includes(userType) && (
                                            <Grid sx={{ display: "flex" }}>
                                                <IconButton
                                                    disabled={
                                                        setPermissionAddBoolFunc(
                                                            isSideWayB,
                                                            userType,
                                                            objLocationBase.task_id,
                                                            LOCAL_CONSTANT.NAVI.DONATION,
                                                            "sidewalk_select3"
                                                        )}
                                                    onClick={() => {handleChatBubbleClick("sidewalk_select3");}}
                                                    sx={iconHover}
                                                >
                                                    <Box
                                                        sx={chatBubbleErrorAddBoolSx(
                                                            isSideWayB,
                                                            userType,
                                                            objLocationBase.task_id,
                                                            LOCAL_CONSTANT.NAVI.DONATION,
                                                            "sidewalk_select3",
                                                            listDeficiencyComment
                                                        )}
                                                    >
                                                        <ChatBubbleIcon sx={chatBubbleIconSx}/>
                                                    </Box>
                                                </IconButton>
                                                {userType === LOCAL_CONSTANT.USER_TYPE.RR && (
                                                    <IconButton
                                                        disabled={isSideWayB}
                                                        onClick={() => {handleEditIconClick("sidewalk_select3");}}
                                                        sx={iconHover}
                                                    >
                                                        <Box sx={editIconCircleSx}><EditIcon /></Box>
                                                    </IconButton>
                                                )}
                                            </Grid>
                                        )}
                                    </Box>
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    <Box sx={{ display: "flex" }}>
                                        {isBackstreet === true && (
                                            <FormControl fullWidth>
                                                <Select
                                                    onChange={(e) => handleSelectChange(e, "sidewalk_select4")}
                                                    value={objDonation.sidewalk_select4}
                                                    sx={inactiveSelectStyle}
                                                    disabled={true}
                                                >
                                                    {commonYesnone?.map(
                                                        (row: any) => (
                                                            <MenuItem key={row.code_value} value={row.code_value}>
                                                                {row.code_display}
                                                            </MenuItem>
                                                        )
                                                    )}
                                                </Select>
                                            </FormControl>
                                        )}
                                        {isBackstreet === false && (
                                            <FormControl fullWidth>
                                                <Select
                                                    onChange={(e) => handleSelectChange(e, "sidewalk_select4")}
                                                    value={objDonation.sidewalk_select4}
                                                    sx={selectStyle(
                                                        userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                            ? setPermissionFunc(
                                                                userType,
                                                                objLocationBase.task_id,
                                                                LOCAL_CONSTANT.NAVI.DONATION,
                                                                "sidewalk_select4"
                                                            )
                                                            : donationReadOnlyObj.sidewalk_select4,
                                                        objRrBranchLog,
                                                        objRequestErrorList,
                                                        listDeficiencyComment,
                                                        "sidewalk_select4",
                                                        objDonation.sidewalk_select4
                                                    )}
                                                    disabled={
                                                        userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                            ? setPermissionFunc(
                                                                userType,
                                                                objLocationBase.task_id,
                                                                LOCAL_CONSTANT.NAVI.DONATION,
                                                                "sidewalk_select4"
                                                            )
                                                            : donationReadOnlyObj.sidewalk_select4
                                                    }
                                                >
                                                    {commonYesnone?.map(
                                                        (row: any) => (
                                                            <MenuItem key={row.code_value} value={row.code_value}>
                                                                {row.code_display}
                                                            </MenuItem>
                                                        )
                                                    )}
                                                </Select>
                                            </FormControl>
                                        )}
                                        {/* RFCの場合、不備コメント 吹き出しアイコンを表示 */}
                                        {/* RRの場合、不備コメント 吹き出しと編集アイコンを表示 */}
                                        {LOCAL_CONSTANT.USER_TYPE.RFC_RR.includes(userType) && (
                                            <Grid sx={{ display: "flex" }}>
                                                <IconButton
                                                    disabled={setPermissionAddBoolFunc(
                                                        isBackstreet,
                                                        userType,
                                                        objLocationBase.task_id,
                                                        LOCAL_CONSTANT.NAVI.DONATION,
                                                        "sidewalk_select4"
                                                    )}
                                                    onClick={() => {handleChatBubbleClick("sidewalk_select4");}}
                                                    sx={iconHover}
                                                >
                                                    <Box
                                                        sx={chatBubbleErrorAddBoolSx(
                                                            isBackstreet,
                                                            userType,
                                                            objLocationBase.task_id,
                                                            LOCAL_CONSTANT.NAVI.DONATION,
                                                            "sidewalk_select4",
                                                            listDeficiencyComment
                                                        )}
                                                    >
                                                        <ChatBubbleIcon sx={chatBubbleIconSx}/>
                                                    </Box>
                                                </IconButton>
                                                {userType === LOCAL_CONSTANT.USER_TYPE.RR && (
                                                    <IconButton
                                                        disabled={isBackstreet}
                                                        onClick={() => {handleEditIconClick("sidewalk_select4");}}
                                                        sx={iconHover}
                                                    >
                                                        <Box sx={editIconCircleSx}><EditIcon /></Box>
                                                    </IconButton>
                                                )}
                                            </Grid>
                                        )}
                                    </Box>
                                </TableCell>
                            </TableRow>

                            {/* 歩道 高さ */}
                            <TableRow sx={bottomCellLabelStyle}>
                                <TableCell sx={cellLabelStyle}>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            width: "65px",
                                        }}
                                    >
                                        <InputLabel>高さ</InputLabel>
                                        <RedAsterisk>＊＊</RedAsterisk>
                                    </Box>
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    <InputWithIcons
                                        props={{
                                            userType: userType, //ユーザー
                                            disabled: !(
                                                !setPermissionFunc(
                                                    userType,
                                                    objLocationBase.task_id,
                                                    LOCAL_CONSTANT.NAVI.DONATION,
                                                    "sidewalk_height"
                                                ) &&
                                                objDonation.sidewalk_select === "1"
                                            ), //ユーザー権限
                                            pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                            labelName: "sidewalk_height",
                                            startAdornment: "",
                                            endAdornment: "cm",
                                            InputValueObj: donation,
                                            ReadOnlyObj: donationReadOnlyObj,
                                            setReadOnlyObj: setDonationReadOnlyObj,
                                            ShowEditIconObj: initDonationShowEditIconObj,
                                            ShowIconsObj: donationShowIconsObj,
                                            handleChatBubbleClick: handleChatBubbleClick,
                                            handleInputBlur: handleInputBlur,
                                            handleInputChange: handleIntOrDecimalInputChange,
                                            handleInputClick: handleInputClick,
                                        }}
                                    />
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    {isSideWayA === true && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: true, //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "sidewalk_height2",
                                                startAdornment: "",
                                                endAdornment: "cm",
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                    {isSideWayA === false && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: !(
                                                    !setPermissionFunc(
                                                        userType,
                                                        objLocationBase.task_id,
                                                        LOCAL_CONSTANT.NAVI.DONATION,
                                                        "sidewalk_height2"
                                                    ) &&
                                                    objDonation.sidewalk_select2 === "1"
                                                ), //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "sidewalk_height2",
                                                startAdornment: "",
                                                endAdornment: "cm",
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    {isSideWayB === true && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: true, //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "sidewalk_height3",
                                                startAdornment: "",
                                                endAdornment: "cm",
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                    {isSideWayB === false && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: !(
                                                    !setPermissionFunc(
                                                        userType,
                                                        objLocationBase.task_id,
                                                        LOCAL_CONSTANT.NAVI.DONATION,
                                                        "sidewalk_height3"
                                                    ) &&
                                                    objDonation.sidewalk_select3 === "1"
                                                ), //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "sidewalk_height3",
                                                startAdornment: "",
                                                endAdornment: "cm",
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    {isBackstreet === true && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: true, //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "sidewalk_height4",
                                                startAdornment: "",
                                                endAdornment: "cm",
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                    {isBackstreet === false && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: !(
                                                    !setPermissionFunc(
                                                        userType,
                                                        objLocationBase.task_id,
                                                        LOCAL_CONSTANT.NAVI.DONATION,
                                                        "sidewalk_height4"
                                                    ) &&
                                                    objDonation.sidewalk_select4 === "1"
                                                ), //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "sidewalk_height4",
                                                startAdornment: "",
                                                endAdornment: "cm",
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                </TableCell>
                            </TableRow>

                            {/* 車道幅員 ドア */}
                            <TableRow>
                                <TableCell sx={cellLabelStyle} rowSpan={3}>
                                    <Grid container rowSpacing={2}>
                                        <Grid item xs={12}>
                                            <InputLabel sx={titleLabelStyle}>車幅幅員</InputLabel>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <InputLabel sx={descriptionLabelStyle}>片側最大2車線迄</InputLabel>
                                            <InputLabel sx={descriptionLabelStyle}>信号、交差点の中は"0"</InputLabel>
                                            <InputLabel sx={descriptionLabelStyle}>全幅5m未満の場合全幅記入</InputLabel>
                                        </Grid>
                                    </Grid>
                                </TableCell>
                                <TableCell sx={cellLabelStyle}>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            width: "65px",
                                        }}
                                    >
                                        <InputLabel>ドア</InputLabel>
                                        <RedAsterisk>＊</RedAsterisk>
                                    </Box>
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    <InputWithIcons
                                        props={{
                                            userType: userType, //ユーザー
                                            disabled: setPermissionFunc(
                                                userType,
                                                objLocationBase.task_id,
                                                LOCAL_CONSTANT.NAVI.DONATION,
                                                "road_width_door"
                                            ), //ユーザー権限
                                            pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                            labelName: "road_width_door",
                                            startAdornment: "",
                                            endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                            InputValueObj: donation,
                                            ReadOnlyObj: donationReadOnlyObj,
                                            setReadOnlyObj: setDonationReadOnlyObj,
                                            ShowEditIconObj: initDonationShowEditIconObj,
                                            ShowIconsObj: donationShowIconsObj,
                                            handleChatBubbleClick: handleChatBubbleClick,
                                            handleInputBlur: handleInputBlur,
                                            handleInputChange: handleIntOrDecimalInputChange,
                                            handleInputClick: handleInputClick,
                                        }}
                                    />
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    {isSideWayA === true && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: true, //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "road_width_door2",
                                                startAdornment: "",
                                                endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                    {isSideWayA === false && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: setPermissionFunc(
                                                    userType,
                                                    objLocationBase.task_id,
                                                    LOCAL_CONSTANT.NAVI.DONATION,  
                                                    "road_width_door2"
                                                ), //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "road_width_door2",
                                                startAdornment: "",
                                                endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    {isSideWayB === true && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: true, //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "road_width_door3",
                                                startAdornment: "",
                                                endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                    {isSideWayB === false && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: setPermissionFunc(
                                                    userType,
                                                    objLocationBase.task_id,
                                                    LOCAL_CONSTANT.NAVI.DONATION,
                                                    "road_width_door3"
                                                ), //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "road_width_door3",
                                                startAdornment: "",
                                                endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    {isBackstreet === true && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: true, //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "road_width_door4",
                                                startAdornment: "",
                                                endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                    {isBackstreet === false && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: setPermissionFunc(
                                                    userType,
                                                    objLocationBase.task_id,
                                                    LOCAL_CONSTANT.NAVI.DONATION,
                                                    "road_width_door4"
                                                ), //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "road_width_door4",
                                                startAdornment: "",
                                                endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                </TableCell>
                            </TableRow>

                            {/* 車道幅 先 */}
                            <TableRow>
                                <TableCell sx={cellLabelStyle}>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            width: "65px",
                                        }}
                                    >
                                        <InputLabel>先</InputLabel>
                                        <RedAsterisk>＊</RedAsterisk>
                                    </Box>
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    <InputWithIcons
                                        props={{
                                            userType: userType, //ユーザー
                                            disabled: setPermissionFunc(
                                                userType,
                                                objLocationBase.task_id,
                                                LOCAL_CONSTANT.NAVI.DONATION,
                                                "road_width_forward"
                                            ), //ユーザー権限
                                            pageName:
                                                LOCAL_CONSTANT.NAVI.DONATION,
                                            labelName: "road_width_forward",
                                            startAdornment: "",
                                            endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                            InputValueObj: donation,
                                            ReadOnlyObj: donationReadOnlyObj,
                                            setReadOnlyObj: setDonationReadOnlyObj,
                                            ShowEditIconObj: initDonationShowEditIconObj,
                                            ShowIconsObj: donationShowIconsObj,
                                            handleChatBubbleClick: handleChatBubbleClick,
                                            handleInputBlur: handleInputBlur,
                                            handleInputChange: handleIntOrDecimalInputChange,
                                            handleInputClick: handleInputClick,
                                        }}
                                    />
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    {isSideWayA === true && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: true, //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "road_width_forward2",
                                                startAdornment: "",
                                                endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                    {isSideWayA === false && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: setPermissionFunc(
                                                    userType,
                                                    objLocationBase.task_id,
                                                    LOCAL_CONSTANT.NAVI.DONATION,
                                                    "road_width_forward2"
                                                ), //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "road_width_forward2",
                                                startAdornment: "",
                                                endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    {isSideWayB === true && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: true, //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "road_width_forward3",
                                                startAdornment: "",
                                                endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                    {isSideWayB === false && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: setPermissionFunc(
                                                    userType,
                                                    objLocationBase.task_id,
                                                    LOCAL_CONSTANT.NAVI.DONATION,
                                                    "road_width_forward3"
                                                ), //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "road_width_forward3",
                                                startAdornment: "",
                                                endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    {isBackstreet === true && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: true, //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "road_width_forward4",
                                                startAdornment: "",
                                                endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                    {isBackstreet === false && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: setPermissionFunc(
                                                    userType,
                                                    objLocationBase.task_id,
                                                    LOCAL_CONSTANT.NAVI.DONATION,
                                                    "road_width_forward4"
                                                ), //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "road_width_forward4",
                                                startAdornment: "",
                                                endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                </TableCell>
                            </TableRow>

                            {/* 車道幅員 手前 */}
                            <TableRow sx={bottomCellLabelStyle}>
                                <TableCell sx={cellLabelStyle}>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            width: "65px",
                                        }}
                                    >
                                        <InputLabel>手前</InputLabel>
                                        <RedAsterisk>＊</RedAsterisk>
                                    </Box>
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    <InputWithIcons
                                        props={{
                                            userType: userType, //ユーザー
                                            disabled: setPermissionFunc(
                                                userType,
                                                objLocationBase.task_id,
                                                LOCAL_CONSTANT.NAVI.DONATION,
                                                "road_width_front_location"
                                            ), //ユーザー権限
                                            pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                            labelName: "road_width_front_location",
                                            startAdornment: "",
                                            endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                            InputValueObj: donation,
                                            ReadOnlyObj: donationReadOnlyObj,
                                            setReadOnlyObj: setDonationReadOnlyObj,
                                            ShowEditIconObj: initDonationShowEditIconObj,
                                            ShowIconsObj: donationShowIconsObj,
                                            handleChatBubbleClick: handleChatBubbleClick,
                                            handleInputBlur: handleInputBlur,
                                            handleInputChange: handleIntOrDecimalInputChange,
                                            handleInputClick: handleInputClick,
                                        }}
                                    />
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    {isSideWayA === true && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: true, //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "road_width_front_location2",
                                                startAdornment: "",
                                                endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                    {isSideWayA === false && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: setPermissionFunc(
                                                    userType,
                                                    objLocationBase.task_id,
                                                    LOCAL_CONSTANT.NAVI.DONATION,
                                                    "road_width_front_location2"
                                                ), //ユーザー権限
                                                pageName:LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "road_width_front_location2",
                                                startAdornment: "",
                                                endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    {isSideWayB === true && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: true, //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "road_width_front_location3",
                                                startAdornment: "",
                                                endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                    {isSideWayB === false && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: setPermissionFunc(
                                                    userType,
                                                    objLocationBase.task_id,
                                                    LOCAL_CONSTANT.NAVI.DONATION,
                                                    "road_width_front_location3"
                                                ), //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "road_width_front_location3",
                                                startAdornment: "",
                                                endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    {isBackstreet === true && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: true, //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "road_width_front_location4",
                                                startAdornment: "",
                                                endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                    {isBackstreet === false && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: setPermissionFunc(
                                                    userType,
                                                    objLocationBase.task_id,
                                                    LOCAL_CONSTANT.NAVI.DONATION,
                                                    "road_width_front_location4"
                                                ), //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "road_width_front_location4",
                                                startAdornment: "",
                                                endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                </TableCell>
                            </TableRow>

                            {/* 坂道（長さ1ｍ当り）登 */}
                            <TableRow>
                                <TableCell sx={cellLabelStyle} rowSpan={2}>
                                    <Grid container rowSpacing={2}>
                                        <Grid item xs={12}>
                                            <InputLabel sx={titleLabelStyle}>坂道</InputLabel>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <InputLabel sx={descriptionLabelStyle}>長さ1m当り</InputLabel>
                                            <InputLabel sx={descriptionLabelStyle}>店の上手・下手各50m間の平均値</InputLabel>
                                        </Grid>
                                    </Grid>
                                </TableCell>
                                <TableCell sx={cellLabelStyle}>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            width: "65px",
                                        }}
                                    >
                                        <InputLabel>登</InputLabel>
                                        <RedAsterisk>＊</RedAsterisk>
                                    </Box>
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    <InputWithIcons
                                        props={{
                                            userType: userType, //ユーザー
                                            disabled: setPermissionFunc(
                                                userType,
                                                objLocationBase.task_id,
                                                LOCAL_CONSTANT.NAVI.DONATION,
                                                "slope_climb"
                                            ), //ユーザー権限
                                            pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                            labelName: "slope_climb",
                                            startAdornment: "",
                                            endAdornment: "cm",
                                            InputValueObj: donation,
                                            ReadOnlyObj: donationReadOnlyObj,
                                            setReadOnlyObj: setDonationReadOnlyObj,
                                            ShowEditIconObj: initDonationShowEditIconObj,
                                            ShowIconsObj: donationShowIconsObj,
                                            handleChatBubbleClick: handleChatBubbleClick,
                                            handleInputBlur: handleInputBlur,
                                            handleInputChange: handleIntOrDecimalInputChange,
                                            handleInputClick: handleInputClick,
                                        }}
                                    />
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    {isSideWayA === true && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: true, //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "slope_climb2",
                                                startAdornment: "",
                                                endAdornment: "cm",
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                    {isSideWayA === false && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: setPermissionFunc(
                                                    userType,
                                                    objLocationBase.task_id,
                                                    LOCAL_CONSTANT.NAVI.DONATION,
                                                    "slope_climb2"
                                                ), //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "slope_climb2",
                                                startAdornment: "",
                                                endAdornment: "cm",
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj:setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    {isSideWayB === true && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: true, //ユーザー権
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "slope_climb3",
                                                startAdornment: "",
                                                endAdornment: "cm",
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                    {isSideWayB === false && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: setPermissionFunc(
                                                    userType,
                                                    objLocationBase.task_id,
                                                    LOCAL_CONSTANT.NAVI.DONATION,
                                                    "slope_climb3"
                                                ), //ユーザー権
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "slope_climb3",
                                                startAdornment: "",
                                                endAdornment: "cm",
                                                InputValueObj: donation,
                                                ReadOnlyObj:donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    {isBackstreet === true && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: true, //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "slope_climb4",
                                                startAdornment: "",
                                                endAdornment: "cm",
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                    {isBackstreet === false && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: setPermissionFunc(
                                                    userType,
                                                    objLocationBase.task_id,
                                                    LOCAL_CONSTANT.NAVI.DONATION,
                                                    "slope_climb4"
                                                ), //ユーザー権限
                                                pageName:
                                                    LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "slope_climb4",
                                                startAdornment: "",
                                                endAdornment: "cm",
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                </TableCell>
                            </TableRow>

                            {/* 坂道（長さ1ｍ当り）降 */}
                            <TableRow sx={bottomCellLabelStyle}>
                                <TableCell sx={cellLabelStyle}>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            width: "65px",
                                        }}
                                    >
                                        <InputLabel>降</InputLabel>
                                        <RedAsterisk>＊</RedAsterisk>
                                    </Box>
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    <InputWithIcons
                                        props={{
                                            userType: userType, //ユーザー
                                            disabled: setPermissionFunc(
                                                userType,
                                                objLocationBase.task_id,
                                                LOCAL_CONSTANT.NAVI.DONATION,
                                                "slope_descend"
                                            ), //ユーザー権限
                                            pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                            labelName: "slope_descend",
                                            startAdornment: "",
                                            endAdornment: "cm",
                                            InputValueObj: donation,
                                            ReadOnlyObj: donationReadOnlyObj,
                                            setReadOnlyObj: setDonationReadOnlyObj,
                                            ShowEditIconObj: initDonationShowEditIconObj,
                                            ShowIconsObj: donationShowIconsObj,
                                            handleChatBubbleClick: handleChatBubbleClick,
                                            handleInputBlur: handleInputBlur,
                                            handleInputChange: handleIntOrDecimalInputChange,
                                            handleInputClick: handleInputClick,
                                        }}
                                    />
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    {isSideWayA === true && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: true, //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "slope_descend2",
                                                startAdornment: "",
                                                endAdornment: "cm",
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                    {isSideWayA === false && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: setPermissionFunc(
                                                    userType,
                                                    objLocationBase.task_id,
                                                    LOCAL_CONSTANT.NAVI.DONATION, 
                                                    "slope_descend2"
                                                ), //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "slope_descend2",
                                                startAdornment: "",
                                                endAdornment: "cm",
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    {isSideWayB === true && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: true, //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "slope_descend3",
                                                startAdornment: "",
                                                endAdornment: "cm",
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                    {isSideWayB === false && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: setPermissionFunc(
                                                    userType,
                                                    objLocationBase.task_id,
                                                    LOCAL_CONSTANT.NAVI.DONATION,
                                                    "slope_descend3"
                                                ), //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "slope_descend3",
                                                startAdornment: "",
                                                endAdornment: "cm",
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    {isBackstreet === true && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: true, //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "slope_descend4",
                                                startAdornment: "",
                                                endAdornment: "cm",
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur:handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                    {isBackstreet === false && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: setPermissionFunc(
                                                    userType,
                                                    objLocationBase.task_id,
                                                    LOCAL_CONSTANT.NAVI.DONATION,
                                                    "slope_descend4"
                                                ), //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "slope_descend4",
                                                startAdornment: "",
                                                endAdornment: "cm",
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                </TableCell>
                            </TableRow>

                            {/* 信号・踏切先 有無 */}
                            <TableRow>
                                <TableCell sx={cellLabelStyle} rowSpan={2}>
                                    <Grid container rowSpacing={2}>
                                        <Grid item xs={12}>
                                            <InputLabel sx={titleLabelStyle}>信号・踏切　先</InputLabel>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <InputLabel sx={descriptionLabelStyle}>信号付き交差点の中は"有り","0m"</InputLabel>
                                        </Grid>
                                    </Grid>
                                </TableCell>
                                <TableCell sx={cellLabelStyle}>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            width: "65px",
                                        }}
                                    >
                                        <InputLabel>有無</InputLabel>
                                        <RedAsterisk>＊</RedAsterisk>
                                    </Box>
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    <Box sx={{ display: "flex" }}>
                                        <FormControl fullWidth>
                                            <Select
                                                onChange={(e) => handleSelectChange(e, "traffic_signal_etc_forward_select")}
                                                value={objDonation.traffic_signal_etc_forward_select}
                                                sx={selectStyle(
                                                    userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                        ? setPermissionFunc(
                                                            userType,
                                                            objLocationBase.task_id,
                                                            LOCAL_CONSTANT.NAVI.DONATION,
                                                            "traffic_signal_etc_forward_select"
                                                        )
                                                        : donationReadOnlyObj.traffic_signal_etc_forward_select,
                                                    objRrBranchLog,
                                                    objRequestErrorList,
                                                    listDeficiencyComment,
                                                    "traffic_signal_etc_forward_select",
                                                    objDonation.traffic_signal_etc_forward_select
                                                )}
                                                disabled={
                                                    userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                        ? setPermissionFunc(
                                                            userType,
                                                            objLocationBase.task_id,
                                                            LOCAL_CONSTANT.NAVI.DONATION,  
                                                            "traffic_signal_etc_forward_select"
                                                        )
                                                        : donationReadOnlyObj.traffic_signal_etc_forward_select
                                                }
                                            >
                                                {commonYesnone?.map(
                                                    (row: any) => (
                                                        <MenuItem key={row.code_value} value={row.code_value}>
                                                            {row.code_display}
                                                        </MenuItem>
                                                    )
                                                )}
                                            </Select>
                                        </FormControl>
                                        {/* RFCの場合、不備コメント 吹き出しアイコンを表示 */}
                                        {/* RRの場合、不備コメント 吹き出しと編集アイコンを表示 */}
                                        {LOCAL_CONSTANT.USER_TYPE.RFC_RR.includes(userType) && (
                                            <Grid sx={{ display: "flex" }}>
                                                <IconButton
                                                    disabled={setPermissionFunc(
                                                        userType,
                                                        objLocationBase.task_id,
                                                        LOCAL_CONSTANT.NAVI.DONATION,
                                                        "traffic_signal_etc_forward_select"
                                                    )}
                                                    onClick={() => {handleChatBubbleClick("traffic_signal_etc_forward_select");}}
                                                    sx={iconHover}
                                                >
                                                    <Box
                                                        sx={chatBubbleErrorSx(
                                                            userType,
                                                            objLocationBase.task_id,
                                                            LOCAL_CONSTANT.NAVI.DONATION,
                                                            "traffic_signal_etc_forward_select",
                                                            listDeficiencyComment
                                                        )}
                                                    >
                                                        <ChatBubbleIcon sx={chatBubbleIconSx}/>
                                                    </Box>
                                                </IconButton>
                                                {userType === LOCAL_CONSTANT.USER_TYPE.RR && (
                                                    <IconButton
                                                        onClick={() => {handleEditIconClick("traffic_signal_etc_forward_select");}}
                                                        sx={iconHover}
                                                    >
                                                        <Box sx={editIconCircleSx}><EditIcon /></Box>
                                                    </IconButton>
                                                )}

                                            </Grid>
                                        )}
                                    </Box>
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    <Box sx={{ display: "flex" }}>
                                        {isSideWayA === true && (
                                            <FormControl fullWidth>
                                                <Select
                                                    onChange={(e) => handleSelectChange(e, "traffic_signal_etc_forward_select2")}
                                                    value={objDonation.traffic_signal_etc_forward_select2}
                                                    sx={inactiveSelectStyle}
                                                    disabled={true}
                                                >
                                                    {commonYesnone?.map(
                                                        (row: any) => (
                                                            <MenuItem key={row.code_value} value={row.code_value}>
                                                                {row.code_display}
                                                            </MenuItem>
                                                        )
                                                    )}
                                                </Select>
                                            </FormControl>
                                        )}
                                        {isSideWayA === false && (
                                            <FormControl fullWidth>
                                                <Select
                                                    onChange={(e) => handleSelectChange(e, "traffic_signal_etc_forward_select2")}
                                                    value={objDonation.traffic_signal_etc_forward_select2}
                                                    sx={selectStyle(
                                                        userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                            ? setPermissionFunc(
                                                                userType,
                                                                objLocationBase.task_id,
                                                                LOCAL_CONSTANT.NAVI.DONATION,
                                                                "traffic_signal_etc_forward_select2"
                                                            )
                                                            : donationReadOnlyObj.traffic_signal_etc_forward_select2,
                                                        objRrBranchLog,
                                                        objRequestErrorList,
                                                        listDeficiencyComment,
                                                        "traffic_signal_etc_forward_select2",
                                                        objDonation.traffic_signal_etc_forward_select2
                                                    )}
                                                    disabled={
                                                        userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                            ? setPermissionFunc(
                                                                userType,
                                                                objLocationBase.task_id,
                                                                LOCAL_CONSTANT.NAVI.DONATION,
                                                                "traffic_signal_etc_forward_select2"
                                                            )
                                                            : donationReadOnlyObj.traffic_signal_etc_forward_select2
                                                    }
                                                >
                                                    {commonYesnone?.map(
                                                        (row: any) => (
                                                            <MenuItem key={row.code_value} value={row.code_value}>
                                                                {row.code_display}
                                                            </MenuItem>
                                                        )
                                                    )}
                                                </Select>
                                            </FormControl>
                                        )}
                                        {/* RFCの場合、不備コメント 吹き出しアイコンを表示 */}
                                        {/* RRの場合、不備コメント 吹き出しと編集アイコンを表示 */}
                                        {LOCAL_CONSTANT.USER_TYPE.RFC_RR.includes(userType) && (
                                            <Grid sx={{ display: "flex" }}>
                                                <IconButton
                                                    disabled={
                                                        setPermissionAddBoolFunc(
                                                            isSideWayA,
                                                            userType,
                                                            objLocationBase.task_id,
                                                            LOCAL_CONSTANT.NAVI.DONATION,
                                                            "traffic_signal_etc_forward_select2"
                                                        )
                                                    }
                                                    onClick={() => {handleChatBubbleClick("traffic_signal_etc_forward_select2");}}
                                                    sx={iconHover}
                                                >
                                                    <Box
                                                        sx={chatBubbleErrorAddBoolSx(
                                                            isSideWayA,
                                                            userType,
                                                            objLocationBase.task_id,
                                                            LOCAL_CONSTANT.NAVI.DONATION,
                                                            "traffic_signal_etc_forward_select2",
                                                            listDeficiencyComment
                                                        )}
                                                    >
                                                        <ChatBubbleIcon sx={chatBubbleIconSx}/>
                                                    </Box>
                                                </IconButton>
                                                {userType === LOCAL_CONSTANT.USER_TYPE.RR && (
                                                    <IconButton
                                                        disabled={isSideWayA}
                                                        onClick={() => {handleEditIconClick("traffic_signal_etc_forward_select2");}}
                                                        sx={iconHover}
                                                    >
                                                        <Box sx={editIconCircleSx}><EditIcon /></Box>
                                                    </IconButton>
                                                )}
                                            </Grid>
                                        )}
                                    </Box>
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    <Box sx={{ display: "flex" }}>
                                        {isSideWayB === true && (
                                            <FormControl fullWidth>
                                                <Select
                                                    onChange={(e) => handleSelectChange(e, "traffic_signal_etc_forward_select3")}
                                                    value={objDonation.traffic_signal_etc_forward_select3}
                                                    sx={inactiveSelectStyle}
                                                    disabled={true}
                                                >
                                                    {commonYesnone?.map(
                                                        (row: any) => (
                                                            <MenuItem key={row.code_value} value={row.code_value}>
                                                                {row.code_display}
                                                            </MenuItem>
                                                        )
                                                    )}
                                                </Select>
                                            </FormControl>
                                        )}
                                        {isSideWayB === false && (
                                            <FormControl fullWidth>
                                                <Select
                                                    onChange={(e) => handleSelectChange(e, "traffic_signal_etc_forward_select3")}
                                                    value={objDonation.traffic_signal_etc_forward_select3}
                                                    sx={selectStyle(
                                                        userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                            ? setPermissionFunc(
                                                                userType,
                                                                objLocationBase.task_id,
                                                                LOCAL_CONSTANT.NAVI.DONATION,
                                                                "traffic_signal_etc_forward_select3"
                                                            )
                                                            : donationReadOnlyObj.traffic_signal_etc_forward_select3,
                                                        objRrBranchLog,
                                                        objRequestErrorList,
                                                        listDeficiencyComment,
                                                        "traffic_signal_etc_forward_select3",
                                                        objDonation.traffic_signal_etc_forward_select3
                                                    )}
                                                    disabled={
                                                        userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                            ? setPermissionFunc(
                                                                userType,
                                                                objLocationBase.task_id,
                                                                LOCAL_CONSTANT.NAVI.DONATION,
                                                                "traffic_signal_etc_forward_select3"
                                                            )
                                                            : donationReadOnlyObj.traffic_signal_etc_forward_select3
                                                    }
                                                >
                                                    {commonYesnone?.map(
                                                        (row: any) => (
                                                            <MenuItem key={row.code_value} value={row.code_value}>
                                                                {row.code_display}
                                                            </MenuItem>
                                                        )
                                                    )}
                                                </Select>
                                            </FormControl>
                                        )}
                                        {/* RFCの場合、不備コメント 吹き出しアイコンを表示 */}
                                        {/* RRの場合、不備コメント 吹き出しと編集アイコンを表示 */}
                                        {LOCAL_CONSTANT.USER_TYPE.RFC_RR.includes(userType) && (
                                            <Grid sx={{ display: "flex" }}>
                                                <IconButton
                                                    disabled={
                                                        setPermissionAddBoolFunc(
                                                            isSideWayB,
                                                            userType,
                                                            objLocationBase.task_id,
                                                            LOCAL_CONSTANT.NAVI.DONATION,
                                                            "traffic_signal_etc_forward_select3"
                                                        )
                                                    }
                                                    onClick={() => {handleChatBubbleClick("traffic_signal_etc_forward_select3");}}
                                                    sx={iconHover}
                                                >
                                                    <Box
                                                        sx={chatBubbleErrorAddBoolSx(
                                                            isSideWayB,
                                                            userType,
                                                            objLocationBase.task_id,
                                                            LOCAL_CONSTANT.NAVI.DONATION,
                                                            "traffic_signal_etc_forward_select3",
                                                            listDeficiencyComment
                                                        )}
                                                    >
                                                        <ChatBubbleIcon sx={chatBubbleIconSx}/>
                                                    </Box>
                                                </IconButton>
                                                {userType === LOCAL_CONSTANT.USER_TYPE.RR && (
                                                    <IconButton
                                                        disabled={isSideWayB}
                                                        onClick={() => {handleEditIconClick("traffic_signal_etc_forward_select3");}}
                                                        sx={iconHover}
                                                    >
                                                        <Box sx={editIconCircleSx}><EditIcon /></Box>
                                                    </IconButton>
                                                )}
                                            </Grid>
                                        )}
                                    </Box>
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    <Box sx={{ display: "flex" }}>
                                        {isBackstreet === true && (
                                            <FormControl fullWidth>
                                                <Select
                                                    onChange={(e) => handleSelectChange(e, "traffic_signal_etc_forward_select4")}
                                                    value={objDonation.traffic_signal_etc_forward_select4}
                                                    sx={inactiveSelectStyle}
                                                    disabled={true}
                                                >
                                                    {commonYesnone?.map(
                                                        (row: any) => (
                                                            <MenuItem key={row.code_value} value={row.code_value}>
                                                                {row.code_display}
                                                            </MenuItem>
                                                        )
                                                    )}
                                                </Select>
                                            </FormControl>
                                        )}
                                        {isBackstreet === false && (
                                            <FormControl fullWidth>
                                                <Select
                                                    onChange={(e) => handleSelectChange(e, "traffic_signal_etc_forward_select4")}
                                                    value={objDonation.traffic_signal_etc_forward_select4}
                                                    sx={selectStyle(
                                                        userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                            ? setPermissionFunc(
                                                                userType,
                                                                objLocationBase.task_id,
                                                                LOCAL_CONSTANT.NAVI.DONATION,
                                                                "traffic_signal_etc_forward_select4"
                                                            )
                                                            : donationReadOnlyObj.traffic_signal_etc_forward_select4,
                                                        objRrBranchLog,
                                                        objRequestErrorList,
                                                        listDeficiencyComment,
                                                        "traffic_signal_etc_forward_select4",
                                                        objDonation.traffic_signal_etc_forward_select4
                                                    )}
                                                    disabled={
                                                        userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                            ? setPermissionFunc(
                                                                userType,
                                                                objLocationBase.task_id,
                                                                LOCAL_CONSTANT.NAVI.DONATION,  
                                                                "traffic_signal_etc_forward_select4"
                                                            )
                                                            : donationReadOnlyObj.traffic_signal_etc_forward_select4
                                                    }
                                                >
                                                    {commonYesnone?.map(
                                                        (row: any) => (
                                                            <MenuItem key={row.code_value} value={row.code_value}>
                                                                {row.code_display}
                                                            </MenuItem>
                                                        )
                                                    )}
                                                </Select>
                                            </FormControl>
                                        )}
                                        {/* RFCの場合、不備コメント 吹き出しアイコンを表示 */}
                                        {/* RRの場合、不備コメント 吹き出しと編集アイコンを表示 */}
                                        {LOCAL_CONSTANT.USER_TYPE.RFC_RR.includes(userType) && (
                                            <Grid sx={{ display: "flex" }}>
                                                <IconButton
                                                    disabled={
                                                        setPermissionAddBoolFunc(
                                                            isBackstreet,
                                                            userType,
                                                            objLocationBase.task_id,
                                                            LOCAL_CONSTANT.NAVI.DONATION,
                                                            "traffic_signal_etc_forward_select4"
                                                        )
                                                    }
                                                    onClick={() => {handleChatBubbleClick("traffic_signal_etc_forward_select4");}}
                                                    sx={iconHover}
                                                >
                                                    <Box
                                                        sx={chatBubbleErrorAddBoolSx(
                                                                isBackstreet,
                                                                userType,
                                                                objLocationBase.task_id,
                                                                LOCAL_CONSTANT.NAVI.DONATION,
                                                                "traffic_signal_etc_forward_select4",
                                                                listDeficiencyComment
                                                            )
                                                        }
                                                    >
                                                        <ChatBubbleIcon sx={chatBubbleIconSx}/>
                                                    </Box>
                                                </IconButton>
                                                {userType === LOCAL_CONSTANT.USER_TYPE.RR && (
                                                    <IconButton
                                                        disabled={isBackstreet}
                                                        onClick={() => {handleEditIconClick("traffic_signal_etc_forward_select4");}}
                                                        sx={iconHover}
                                                    >
                                                        <Box sx={editIconCircleSx}><EditIcon /></Box>
                                                    </IconButton>
                                                )}
                                            </Grid>
                                        )}
                                    </Box>
                                </TableCell>
                            </TableRow>

                            {/* 信号・踏切先 距離 */}
                            <TableRow sx={bottomCellLabelStyle}>
                                <TableCell sx={cellLabelStyle}>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            width: "65px",
                                        }}
                                    >
                                        <InputLabel>距離</InputLabel>
                                        <RedAsterisk>＊＊</RedAsterisk>
                                    </Box>
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    <InputWithIcons
                                        props={{
                                            userType: userType, //ユーザー
                                            disabled: !(
                                                !setPermissionFunc(
                                                    userType,
                                                    objLocationBase.task_id,
                                                    LOCAL_CONSTANT.NAVI.DONATION,
                                                    "traffic_signal_etc_forward_distance"
                                                ) && objDonation.traffic_signal_etc_forward_select === "1"
                                            ), //ユーザー権限
                                            pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                            labelName: "traffic_signal_etc_forward_distance",
                                            startAdornment: "",
                                            endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                            InputValueObj: donation,
                                            ReadOnlyObj: donationReadOnlyObj,
                                            setReadOnlyObj: setDonationReadOnlyObj,
                                            ShowEditIconObj: initDonationShowEditIconObj,
                                            ShowIconsObj: donationShowIconsObj,
                                            handleChatBubbleClick: handleChatBubbleClick,
                                            handleInputBlur: handleInputBlur,
                                            handleInputChange: handleIntOrDecimalInputChange,
                                            handleInputClick: handleInputClick,
                                        }}
                                    />
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    {isSideWayA === true && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: true, //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "traffic_signal_etc_forward_distance2",
                                                startAdornment: "",
                                                endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                    {isSideWayA === false && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: !(
                                                    !setPermissionFunc(
                                                        userType,
                                                        objLocationBase.task_id,
                                                        LOCAL_CONSTANT.NAVI.DONATION,
                                                        "traffic_signal_etc_forward_distance2"
                                                    ) && objDonation.traffic_signal_etc_forward_select2 === "1"
                                                ), //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "traffic_signal_etc_forward_distance2",
                                                startAdornment: "",
                                                endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    {isSideWayB === true && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: true, //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "traffic_signal_etc_forward_distance3",
                                                startAdornment: "",
                                                endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                    {isSideWayB === false && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: !(
                                                    !setPermissionFunc(
                                                        userType,
                                                        objLocationBase.task_id,
                                                        LOCAL_CONSTANT.NAVI.DONATION,
                                                        "traffic_signal_etc_forward_distance3"
                                                    ) && objDonation.traffic_signal_etc_forward_select3 === "1"
                                                ), //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "traffic_signal_etc_forward_distance3",
                                                startAdornment: "",
                                                endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    {isBackstreet === true && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: true, //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "traffic_signal_etc_forward_distance4",
                                                startAdornment: "",
                                                endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                    {isBackstreet === false && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: !(
                                                    !setPermissionFunc(
                                                        userType,
                                                        objLocationBase.task_id,
                                                        LOCAL_CONSTANT.NAVI.DONATION,
                                                        "traffic_signal_etc_forward_distance4"
                                                    ) && objDonation.traffic_signal_etc_forward_select4 === "1"
                                                ), //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "traffic_signal_etc_forward_distance4",
                                                startAdornment: "",
                                                endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,  
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                </TableCell>
                            </TableRow>

                            {/* 信号・踏切手前 有無 */}
                            <TableRow>
                                <TableCell sx={cellLabelStyle} rowSpan={2}>
                                    <Grid container rowSpacing={2}>
                                        <Grid item xs={12}>
                                            <InputLabel sx={titleLabelStyle}>信号・踏切　手前</InputLabel>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <InputLabel sx={descriptionLabelStyle}>停止線から測定する</InputLabel>
                                            <InputLabel sx={descriptionLabelStyle}>最遠200m迄</InputLabel>
                                        </Grid>
                                    </Grid>
                                </TableCell>
                                <TableCell sx={cellLabelStyle}>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            width: "65px",
                                        }}
                                    >
                                        <InputLabel>有無</InputLabel>
                                        <RedAsterisk>＊</RedAsterisk>
                                    </Box>
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    <Box sx={{ display: "flex" }}>
                                        <FormControl fullWidth>
                                            <Select
                                                onChange={(e) => handleSelectChange(e, "traffic_signal_etc_front_location_select")}
                                                value={objDonation.traffic_signal_etc_front_location_select}   
                                                sx={selectStyle(
                                                    userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                        ? setPermissionFunc(
                                                            userType,
                                                            objLocationBase.task_id,
                                                            LOCAL_CONSTANT.NAVI.DONATION,
                                                            "traffic_signal_etc_front_location_select"
                                                        )
                                                        : donationReadOnlyObj.traffic_signal_etc_front_location_select,
                                                    objRrBranchLog,
                                                    objRequestErrorList,
                                                    listDeficiencyComment,
                                                    "traffic_signal_etc_front_location_select",
                                                    objDonation.traffic_signal_etc_front_location_select
                                                )}
                                                disabled={
                                                    userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                        ? setPermissionFunc(
                                                            userType,
                                                            objLocationBase.task_id,
                                                            LOCAL_CONSTANT.NAVI.DONATION,
                                                            "traffic_signal_etc_front_location_select"
                                                        )
                                                        : donationReadOnlyObj.traffic_signal_etc_front_location_select
                                                }
                                            >
                                                {commonYesnone?.map(
                                                    (row: any) => (
                                                        <MenuItem key={row.code_value} value={row.code_value}>
                                                            {row.code_display}
                                                        </MenuItem>
                                                    )
                                                )}
                                            </Select>
                                        </FormControl>
                                        {/* RFCの場合、不備コメント 吹き出しアイコンを表示 */}
                                        {/* RRの場合、不備コメント 吹き出しと編集アイコンを表示 */}
                                        {LOCAL_CONSTANT.USER_TYPE.RFC_RR.includes(userType) && (
                                            <Grid sx={{ display: "flex" }}>
                                                <IconButton
                                                    disabled={setPermissionFunc(
                                                        userType,
                                                        objLocationBase.task_id,
                                                        LOCAL_CONSTANT.NAVI.DONATION,
                                                        "traffic_signal_etc_front_location_select"
                                                    )}
                                                    onClick={() => {handleChatBubbleClick("traffic_signal_etc_front_location_select");}}
                                                    sx={iconHover}
                                                >
                                                    <Box
                                                        sx={chatBubbleErrorSx(
                                                            userType,
                                                            objLocationBase.task_id,
                                                            LOCAL_CONSTANT.NAVI.DONATION,
                                                            "traffic_signal_etc_front_location_select",
                                                            listDeficiencyComment
                                                        )}
                                                    >
                                                        <ChatBubbleIcon sx={chatBubbleIconSx}/>
                                                    </Box>
                                                </IconButton>
                                                {userType === LOCAL_CONSTANT.USER_TYPE.RR && (
                                                    <IconButton
                                                        onClick={() => {handleEditIconClick("traffic_signal_etc_front_location_select");}}
                                                        sx={iconHover}
                                                    >
                                                        <Box sx={editIconCircleSx}><EditIcon /></Box>
                                                    </IconButton>
                                                )}
                                            </Grid>
                                        )}
                                    </Box>
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    <Box sx={{ display: "flex" }}>
                                        {isSideWayA === true && (
                                            <FormControl fullWidth>
                                                <Select
                                                    onChange={(e) => handleSelectChange(e, "traffic_signal_etc_front_location_select2")}
                                                    value={objDonation.traffic_signal_etc_front_location_select2}
                                                    sx={inactiveSelectStyle}
                                                    disabled={true}
                                                >
                                                    {commonYesnone?.map(
                                                        (row: any) => (
                                                            <MenuItem key={row.code_value} value={row.code_value}>
                                                                {row.code_display}
                                                            </MenuItem>
                                                        )
                                                    )}
                                                </Select>
                                            </FormControl>
                                        )}
                                        {isSideWayA === false && (
                                            <FormControl fullWidth>
                                                <Select
                                                    onChange={(e) => handleSelectChange(e, "traffic_signal_etc_front_location_select2")}
                                                    value={objDonation.traffic_signal_etc_front_location_select2}
                                                    sx={selectStyle(
                                                        userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                            ? setPermissionFunc(
                                                                userType,
                                                                objLocationBase.task_id,
                                                                LOCAL_CONSTANT.NAVI.DONATION,
                                                                "traffic_signal_etc_front_location_select2"
                                                            )
                                                            : donationReadOnlyObj.traffic_signal_etc_front_location_select2,
                                                        objRrBranchLog,
                                                        objRequestErrorList,
                                                        listDeficiencyComment,
                                                        "traffic_signal_etc_front_location_select2",
                                                        objDonation.traffic_signal_etc_front_location_select2
                                                    )}
                                                    disabled={
                                                        userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                            ? setPermissionFunc(
                                                                userType,
                                                                objLocationBase.task_id,
                                                                LOCAL_CONSTANT.NAVI.DONATION,
                                                                "traffic_signal_etc_front_location_select2"
                                                            )
                                                            : donationReadOnlyObj.traffic_signal_etc_front_location_select2
                                                    }
                                                >
                                                    {commonYesnone?.map(
                                                        (row: any) => (
                                                            <MenuItem key={row.code_value} value={row.code_value}>
                                                                {row.code_display}
                                                            </MenuItem>
                                                        )
                                                    )}
                                                </Select>
                                            </FormControl>
                                        )}
                                        {/* RFCの場合、不備コメント 吹き出しアイコンを表示 */}
                                        {/* RRの場合、不備コメント 吹き出しと編集アイコンを表示 */}
                                        {LOCAL_CONSTANT.USER_TYPE.RFC_RR.includes(userType) && (
                                            <Grid sx={{ display: "flex" }}>
                                                <IconButton
                                                    disabled={
                                                        setPermissionAddBoolFunc(
                                                            isSideWayA,
                                                            userType,
                                                            objLocationBase.task_id,
                                                            LOCAL_CONSTANT.NAVI.DONATION,
                                                            "traffic_signal_etc_front_location_select2"
                                                        )
                                                    }
                                                    onClick={() => {handleChatBubbleClick("traffic_signal_etc_front_location_select2");}}
                                                    sx={iconHover}
                                                >
                                                    <Box
                                                        sx={chatBubbleErrorAddBoolSx(
                                                            isSideWayA,
                                                            userType,
                                                            objLocationBase.task_id,
                                                            LOCAL_CONSTANT.NAVI.DONATION,
                                                            "traffic_signal_etc_front_location_select2",
                                                            listDeficiencyComment
                                                        )}
                                                    >
                                                        <ChatBubbleIcon sx={chatBubbleIconSx}/>
                                                    </Box>
                                                </IconButton>
                                                {userType === LOCAL_CONSTANT.USER_TYPE.RR && (
                                                    <IconButton
                                                        disabled={isSideWayA}
                                                        onClick={() => {handleEditIconClick("traffic_signal_etc_front_location_select2");}}
                                                        sx={iconHover}
                                                    >
                                                        <Box sx={editIconCircleSx}><EditIcon /></Box>
                                                    </IconButton>
                                                )}
                                            </Grid>
                                        )}
                                    </Box>
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    <Box sx={{ display: "flex" }}>
                                        {isSideWayB === true && (
                                            <FormControl fullWidth>
                                                <Select
                                                    onChange={(e) => handleSelectChange(e, "traffic_signal_etc_front_location_select3")}
                                                    value={objDonation.traffic_signal_etc_front_location_select3}
                                                    sx={inactiveSelectStyle}
                                                    disabled={true}
                                                >
                                                    {commonYesnone?.map(
                                                        (row: any) => (
                                                            <MenuItem key={row.code_value} value={row.code_value}>
                                                                {row.code_display}
                                                            </MenuItem>
                                                        )
                                                    )}
                                                </Select>
                                            </FormControl>
                                        )}
                                        {isSideWayB === false && (
                                            <FormControl fullWidth>
                                                <Select
                                                    onChange={(e) => handleSelectChange(e, "traffic_signal_etc_front_location_select3")}
                                                    value={objDonation.traffic_signal_etc_front_location_select3}
                                                    sx={selectStyle(
                                                        userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                            ? setPermissionFunc(
                                                                userType,
                                                                objLocationBase.task_id,
                                                                LOCAL_CONSTANT.NAVI.DONATION,
                                                                "traffic_signal_etc_front_location_select3"
                                                            )
                                                            : donationReadOnlyObj.traffic_signal_etc_front_location_select3,
                                                        objRrBranchLog,
                                                        objRequestErrorList,
                                                        listDeficiencyComment,
                                                        "traffic_signal_etc_front_location_select3",
                                                        objDonation.traffic_signal_etc_front_location_select3
                                                    )}
                                                    disabled={
                                                        userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                            ? setPermissionFunc(
                                                                userType,
                                                                objLocationBase.task_id,
                                                                LOCAL_CONSTANT.NAVI.DONATION,
                                                                "traffic_signal_etc_front_location_select3"
                                                            )
                                                            : donationReadOnlyObj.traffic_signal_etc_front_location_select3
                                                    }
                                                >
                                                    {commonYesnone?.map(
                                                        (row: any) => (
                                                            <MenuItem key={row.code_value} value={row.code_value}>
                                                                {row.code_display}
                                                            </MenuItem>
                                                        )
                                                    )}
                                                </Select>
                                            </FormControl>
                                        )}
                                        {/* RFCの場合、不備コメント 吹き出しアイコンを表示 */}
                                        {/* RRの場合、不備コメント 吹き出しと編集アイコンを表示 */}
                                        {LOCAL_CONSTANT.USER_TYPE.RFC_RR.includes(userType) && (
                                            <Grid sx={{ display: "flex" }}>
                                                <IconButton
                                                    disabled={setPermissionAddBoolFunc(
                                                        isSideWayB,
                                                        userType,
                                                        objLocationBase.task_id,
                                                        LOCAL_CONSTANT.NAVI.DONATION,
                                                        "traffic_signal_etc_front_location_select3"
                                                    )}
                                                    onClick={() => {handleChatBubbleClick("traffic_signal_etc_front_location_select3");}}
                                                    sx={iconHover}
                                                >
                                                    <Box
                                                        sx={chatBubbleErrorAddBoolSx(
                                                            isSideWayB,
                                                            userType,
                                                            objLocationBase.task_id,
                                                            LOCAL_CONSTANT.NAVI.DONATION,
                                                            "traffic_signal_etc_front_location_select3",
                                                            listDeficiencyComment
                                                        )}
                                                    >
                                                        <ChatBubbleIcon sx={chatBubbleIconSx}/>
                                                    </Box>
                                                </IconButton>
                                                {userType === LOCAL_CONSTANT.USER_TYPE.RR && (
                                                    <IconButton
                                                        disabled={isSideWayB}
                                                        onClick={() => {handleEditIconClick("traffic_signal_etc_front_location_select3");}}
                                                        sx={iconHover}
                                                    >
                                                        <Box sx={editIconCircleSx}><EditIcon /></Box>
                                                    </IconButton>
                                                )}
                                            </Grid>
                                        )}
                                    </Box>
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    <Box sx={{ display: "flex" }}>
                                        {isBackstreet === true && (
                                            <FormControl fullWidth>
                                                <Select
                                                    onChange={(e) => handleSelectChange(e, "traffic_signal_etc_front_location_select4")}
                                                    value={objDonation.traffic_signal_etc_front_location_select4}
                                                    sx={inactiveSelectStyle}
                                                    disabled={true}
                                                >
                                                    {commonYesnone?.map(
                                                        (row: any) => (
                                                            <MenuItem key={row.code_value} value={row.code_value}>
                                                                {row.code_display}
                                                            </MenuItem>
                                                        )
                                                    )}
                                                </Select>
                                            </FormControl>
                                        )}
                                        {isBackstreet === false && (
                                            <FormControl fullWidth>
                                                <Select
                                                    onChange={(e) => handleSelectChange(e, "traffic_signal_etc_front_location_select4")}
                                                    value={objDonation.traffic_signal_etc_front_location_select4}
                                                    sx={selectStyle(
                                                        userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                            ? setPermissionFunc(
                                                                userType,
                                                                objLocationBase.task_id,
                                                                LOCAL_CONSTANT.NAVI.DONATION,
                                                                "traffic_signal_etc_front_location_select4"
                                                            )
                                                            : donationReadOnlyObj.traffic_signal_etc_front_location_select4,
                                                        objRrBranchLog,
                                                        objRequestErrorList,
                                                        listDeficiencyComment,
                                                        "traffic_signal_etc_front_location_select4",
                                                        objDonation.traffic_signal_etc_front_location_select4
                                                    )}
                                                    disabled={
                                                        userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                            ? setPermissionFunc(
                                                                userType,
                                                                objLocationBase.task_id,
                                                                LOCAL_CONSTANT.NAVI.DONATION,
                                                                "traffic_signal_etc_front_location_select4"
                                                            )
                                                            : donationReadOnlyObj.traffic_signal_etc_front_location_select4
                                                    }
                                                >
                                                    {commonYesnone?.map(
                                                        (row: any) => (
                                                            <MenuItem key={row.code_value} value={row.code_value}>
                                                                {row.code_display}
                                                            </MenuItem>
                                                        )
                                                    )}
                                                </Select>
                                            </FormControl>
                                        )}
                                        {/* RFCの場合、不備コメント 吹き出しアイコンを表示 */}
                                        {/* RRの場合、不備コメント 吹き出しと編集アイコンを表示 */}
                                        {LOCAL_CONSTANT.USER_TYPE.RFC_RR.includes(userType) && (
                                            <Grid sx={{ display: "flex" }}>
                                                <IconButton
                                                    disabled={setPermissionAddBoolFunc(
                                                        isBackstreet,                                            
                                                        userType,
                                                        objLocationBase.task_id,
                                                        LOCAL_CONSTANT.NAVI.DONATION,
                                                        "traffic_signal_etc_front_location_select4"
                                                    )}
                                                    onClick={() => {handleChatBubbleClick("traffic_signal_etc_front_location_select4");}}
                                                    sx={iconHover}
                                                >
                                                    <Box
                                                        sx={chatBubbleErrorAddBoolSx(
                                                            isBackstreet,
                                                            userType,
                                                            objLocationBase.task_id,
                                                            LOCAL_CONSTANT.NAVI.DONATION,
                                                            "traffic_signal_etc_front_location_select4",
                                                            listDeficiencyComment
                                                        )}
                                                    >
                                                        <ChatBubbleIcon sx={chatBubbleIconSx}/>
                                                    </Box>
                                                </IconButton>
                                                {userType === LOCAL_CONSTANT.USER_TYPE.RR && (
                                                    <IconButton
                                                        disabled={isBackstreet}
                                                        onClick={() => {handleEditIconClick("traffic_signal_etc_front_location_select4");}}
                                                        sx={iconHover}
                                                    >
                                                        <Box sx={editIconCircleSx}><EditIcon /></Box>
                                                    </IconButton>
                                                )}
                                            </Grid>
                                        )}
                                    </Box>
                                </TableCell>
                            </TableRow>

                            {/* 信号・踏切手前 距離 */}
                            <TableRow sx={bottomCellLabelStyle}>
                                <TableCell sx={cellLabelStyle}>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            width: "65px",
                                        }}
                                    >
                                        <InputLabel>距離</InputLabel>
                                        <RedAsterisk>＊＊</RedAsterisk>
                                    </Box>
                                </TableCell>
                                <TableCell sx={tableCell}>
                                <InputWithIcons
                                        props={{
                                            userType: userType, //ユーザー
                                            disabled: !(
                                                !setPermissionFunc(
                                                    userType,
                                                    objLocationBase.task_id,
                                                    LOCAL_CONSTANT.NAVI.DONATION,
                                                    "traffic_signal_etc_front_location_distance"
                                                ) &&
                                                objDonation.traffic_signal_etc_front_location_select === "1"
                                            ), //ユーザー権限
                                            pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                            labelName: "traffic_signal_etc_front_location_distance",
                                            startAdornment: "",
                                            endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                            InputValueObj: donation,
                                            ReadOnlyObj: donationReadOnlyObj,
                                            setReadOnlyObj: setDonationReadOnlyObj,
                                            ShowEditIconObj: initDonationShowEditIconObj,
                                            ShowIconsObj: donationShowIconsObj,
                                            handleChatBubbleClick: handleChatBubbleClick,
                                            handleInputBlur: handleInputBlur,
                                            handleInputChange: handleIntOrDecimalInputChange,
                                            handleInputClick: handleInputClick,
                                        }}
                                    />
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    {isSideWayA === true && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: true, //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "traffic_signal_etc_front_location_distance2",
                                                startAdornment: "",
                                                endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                    {isSideWayA === false && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: !(
                                                    !setPermissionFunc(
                                                        userType,
                                                        objLocationBase.task_id,
                                                        LOCAL_CONSTANT.NAVI.DONATION,
                                                        "traffic_signal_etc_front_location_distance2"
                                                    ) &&
                                                    objDonation.traffic_signal_etc_front_location_select2 === "1"
                                                ), //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "traffic_signal_etc_front_location_distance2",
                                                startAdornment: "",
                                                endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    {isSideWayB === true && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: true, //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "traffic_signal_etc_front_location_distance3",
                                                startAdornment: "",
                                                endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                    {isSideWayB === false && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: !(
                                                    !setPermissionFunc(
                                                        userType,
                                                        objLocationBase.task_id,
                                                        LOCAL_CONSTANT.NAVI.DONATION,
                                                        "traffic_signal_etc_front_location_distance3"
                                                    ) &&
                                                    objDonation.traffic_signal_etc_front_location_select3 === "1"
                                                ), //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "traffic_signal_etc_front_location_distance3",
                                                startAdornment: "",
                                                endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    {isBackstreet === true && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: true, //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "traffic_signal_etc_front_location_distance4",
                                                startAdornment: "",
                                                endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                    {isBackstreet === false && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: !(
                                                    !setPermissionFunc(
                                                        userType,
                                                        objLocationBase.task_id,
                                                        LOCAL_CONSTANT.NAVI.DONATION,
                                                        "traffic_signal_etc_front_location_distance4"
                                                    ) &&
                                                    objDonation.traffic_signal_etc_front_location_select4 === "1"
                                                ), //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "traffic_signal_etc_front_location_distance4",
                                                startAdornment: "",
                                                endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                </TableCell>
                            </TableRow>

                            {/* 視界性 建物 */}
                            <TableRow>
                                <TableCell sx={cellLabelStyle} rowSpan={2}>
                                    <Grid container rowSpacing={2}>
                                        <Grid item xs={12}>
                                            <InputLabel sx={titleLabelStyle}>視界性</InputLabel>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <InputLabel sx={descriptionLabelStyle}>建物=店頭看板の"7"</InputLabel>
                                            <InputLabel sx={descriptionLabelStyle}>サインポール=150m間5回計測</InputLabel>
                                        </Grid>
                                    </Grid>
                                </TableCell>
                                <TableCell sx={cellLabelStyle}>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            width: "65px",
                                        }}
                                    >
                                        <InputLabel>建物</InputLabel>
                                        <RedAsterisk>＊</RedAsterisk>
                                    </Box>
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    <InputWithIcons
                                        props={{
                                            userType: userType, //ユーザー
                                            disabled: setPermissionFunc(
                                                userType,
                                                objLocationBase.task_id,
                                                LOCAL_CONSTANT.NAVI.DONATION,
                                                "visibility_factor_building"
                                            ), //ユーザー権限
                                            pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                            labelName: "visibility_factor_building",
                                            startAdornment: "",
                                            endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                            InputValueObj: donation,
                                            ReadOnlyObj: donationReadOnlyObj,
                                            setReadOnlyObj: setDonationReadOnlyObj,
                                            ShowEditIconObj: initDonationShowEditIconObj,
                                            ShowIconsObj: donationShowIconsObj,
                                            handleChatBubbleClick: handleChatBubbleClick,
                                            handleInputBlur: handleInputBlur,
                                            handleInputChange: handleIntOrDecimalInputChange,
                                            handleInputClick: handleInputClick,
                                        }}
                                    />
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    {isSideWayA === true && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: true, //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "visibility_factor_building2",
                                                startAdornment: "",
                                                endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                    {isSideWayA === false && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: setPermissionFunc(
                                                    userType,
                                                    objLocationBase.task_id,
                                                    LOCAL_CONSTANT.NAVI.DONATION,
                                                    "visibility_factor_building2"
                                                ), //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "visibility_factor_building2",
                                                startAdornment: "",
                                                endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    {isSideWayB === true && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: true, //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "visibility_factor_building3",
                                                startAdornment: "",
                                                endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                    {isSideWayB === false && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: setPermissionFunc(
                                                    userType,
                                                    objLocationBase.task_id,
                                                    LOCAL_CONSTANT.NAVI.DONATION,
                                                    "visibility_factor_building3"
                                                ), //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "visibility_factor_building3",
                                                startAdornment: "",
                                                endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    {isBackstreet === true && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: true, //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "visibility_factor_building4",
                                                startAdornment: "",
                                                endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                    {isBackstreet === false && (
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: setPermissionFunc(
                                                    userType,
                                                    objLocationBase.task_id,
                                                    LOCAL_CONSTANT.NAVI.DONATION,
                                                    "visibility_factor_building4"
                                                ), //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "visibility_factor_building4",
                                                startAdornment: "",
                                                endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    )}
                                </TableCell>
                            </TableRow>

                            {/* 視界性 サインポール */}
                            <TableRow sx={bottomCellLabelStyle}>
                                <TableCell sx={cellLabelStyle}>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            width: "70px",
                                        }}
                                    >
                                        <InputLabel>サイン<br />ポール</InputLabel>
                                        <RedAsterisk>＊</RedAsterisk>
                                    </Box>
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    <Box sx={{ display: "flex" }}>
                                        {
                                        <FormControl fullWidth>
                                            <Select
                                                onChange={(e) => handleSelectChange(e, "visibility_factor_sign_post")}
                                                value={objDonation.visibility_factor_sign_post}
                                                sx={selectStyle(
                                                    userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                        ? setPermissionFunc(
                                                            userType,
                                                            objLocationBase.task_id,
                                                            LOCAL_CONSTANT.NAVI.DONATION,
                                                            "visibility_factor_sign_post"
                                                        )
                                                        : donationReadOnlyObj.visibility_factor_sign_post,
                                                    objRrBranchLog,
                                                    objRequestErrorList,
                                                    listDeficiencyComment,
                                                    "visibility_factor_sign_post",
                                                    objDonation.visibility_factor_sign_post
                                                )}
                                                disabled={
                                                    userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                    ? setPermissionFunc(
                                                        userType,
                                                        objLocationBase.task_id,
                                                        LOCAL_CONSTANT.NAVI.DONATION,
                                                        "visibility_factor_sign_post"
                                                    )
                                                    : donationReadOnlyObj.visibility_factor_sign_post
                                                }
                                            >
                                                {visibilityFactorSignPostList?.map(
                                                    (row: any) => (
                                                        <MenuItem key={row.code_value} value={row.code_value}>
                                                            {row.code_display}
                                                        </MenuItem>
                                                    )
                                                )}
                                            </Select>
                                        </FormControl>
                                        }
                                        {/* RFCの場合、不備コメント 吹き出しアイコンを表示 */}
                                        {/* RRの場合、不備コメント 吹き出しと編集アイコンを表示 */}
                                        {LOCAL_CONSTANT.USER_TYPE.RFC_RR.includes(userType) && (
                                            <Grid sx={{ display: "flex" }}>
                                                <IconButton
                                                    disabled={setPermissionFunc(
                                                        userType,
                                                        objLocationBase.task_id,
                                                        LOCAL_CONSTANT.NAVI.DONATION,
                                                        "visibility_factor_sign_post"
                                                    )}
                                                    onClick={() => {handleChatBubbleClick("visibility_factor_sign_post");}}
                                                    sx={iconHover}
                                                >
                                                    <Box
                                                        sx={chatBubbleErrorSx(
                                                            userType,
                                                            objLocationBase.task_id,
                                                            LOCAL_CONSTANT.NAVI.DONATION,
                                                            "visibility_factor_sign_post",
                                                            listDeficiencyComment
                                                        )}
                                                    >
                                                        <ChatBubbleIcon sx={chatBubbleIconSx}/>
                                                    </Box>
                                                </IconButton>
                                                {userType === LOCAL_CONSTANT.USER_TYPE.RR && (
                                                    <IconButton
                                                        onClick={() => {handleEditIconClick("visibility_factor_sign_post");}}
                                                        sx={iconHover}
                                                    >
                                                        <Box sx={editIconCircleSx}><EditIcon /></Box>
                                                    </IconButton>
                                                )}
                                            </Grid>
                                        )}
                                    </Box>
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    <Box sx={{ display: "flex" }}>
                                        {isSideWayA === true && (
                                            <FormControl fullWidth>
                                                <Select
                                                    onChange={(e) => handleSelectChange(e, "visibility_factor_sign_post2")}
                                                    value={objDonation.visibility_factor_sign_post2}
                                                    sx={inactiveSelectStyle}
                                                    disabled={true}
                                                >
                                                    {visibilityFactorSignPostList?.map(
                                                        (row: any) => (
                                                            <MenuItem key={row.code_value} value={row.code_value}>
                                                                {row.code_display}
                                                            </MenuItem>
                                                        )
                                                    )}
                                                </Select>
                                            </FormControl>
                                        )}
                                        {isSideWayA === false && (
                                            <FormControl fullWidth>
                                                <Select
                                                    onChange={(e) => handleSelectChange(e, "visibility_factor_sign_post2")}
                                                    value={objDonation.visibility_factor_sign_post2}
                                                    sx={selectStyle(
                                                        userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                            ? setPermissionFunc(
                                                                userType,
                                                                objLocationBase.task_id,
                                                                LOCAL_CONSTANT.NAVI.DONATION,
                                                                "visibility_factor_sign_post2"
                                                            )
                                                            : donationReadOnlyObj.visibility_factor_sign_post2,
                                                        objRrBranchLog,
                                                        objRequestErrorList,
                                                        listDeficiencyComment,
                                                        "visibility_factor_sign_post2",
                                                        objDonation.visibility_factor_sign_post2
                                                    )}
                                                    disabled={
                                                        userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                            ? setPermissionFunc(
                                                                userType,
                                                                objLocationBase.task_id,
                                                                LOCAL_CONSTANT.NAVI.DONATION,
                                                                "visibility_factor_sign_post2"
                                                            )
                                                            : donationReadOnlyObj.visibility_factor_sign_post2
                                                    }
                                                >
                                                    {visibilityFactorSignPostList?.map(
                                                        (row: any) => (
                                                            <MenuItem key={row.code_value} value={row.code_value}>
                                                                {row.code_display}
                                                            </MenuItem>
                                                        )
                                                    )}
                                                </Select>
                                            </FormControl>
                                        )}
                                        {/* RFCの場合、不備コメント 吹き出しアイコンを表示 */}
                                        {/* RRの場合、不備コメント 吹き出しと編集アイコンを表示 */}
                                        {LOCAL_CONSTANT.USER_TYPE.RFC_RR.includes(userType) && (
                                            <Grid sx={{ display: "flex" }}>
                                                <IconButton
                                                    disabled={setPermissionFunc(
                                                        userType,
                                                        objLocationBase.task_id,
                                                        LOCAL_CONSTANT.NAVI.DONATION,
                                                        "visibility_factor_sign_post2"
                                                    )}
                                                    onClick={() => {handleChatBubbleClick("visibility_factor_sign_post2");}}
                                                    sx={iconHover}
                                                >
                                                    <Box
                                                        sx={chatBubbleErrorSx(
                                                            userType,
                                                            objLocationBase.task_id,
                                                            LOCAL_CONSTANT.NAVI.DONATION,
                                                            "visibility_factor_sign_post2",
                                                            listDeficiencyComment
                                                        )}
                                                    >
                                                        <ChatBubbleIcon sx={chatBubbleIconSx}/>
                                                    </Box>
                                                </IconButton>
                                                {userType === LOCAL_CONSTANT.USER_TYPE.RR && (
                                                    <IconButton
                                                        onClick={() => {handleEditIconClick("visibility_factor_sign_post2");}}
                                                        sx={iconHover}
                                                    >
                                                        <Box sx={editIconCircleSx}><EditIcon /></Box>
                                                    </IconButton>
                                                )}
                                            </Grid>
                                        )}
                                    </Box>
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    <Box sx={{ display: "flex" }}>
                                        {isSideWayB === true && (
                                            <FormControl fullWidth>
                                                <Select
                                                    onChange={(e) => handleSelectChange(e, "visibility_factor_sign_post3")}
                                                    value={objDonation.visibility_factor_sign_post3}
                                                    sx={inactiveSelectStyle}
                                                    disabled={true}
                                                >
                                                    {visibilityFactorSignPostList?.map(
                                                        (row: any) => (
                                                            <MenuItem key={row.code_value} value={row.code_value}>
                                                                {row.code_display}
                                                            </MenuItem>
                                                        )
                                                    )}
                                                </Select>
                                            </FormControl>
                                        )}
                                        {isSideWayB === false && (
                                            <FormControl fullWidth>
                                                <Select
                                                    onChange={(e) => handleSelectChange(e, "visibility_factor_sign_post3")}
                                                    value={objDonation.visibility_factor_sign_post3}
                                                    sx={selectStyle(
                                                        userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                            ? setPermissionFunc(
                                                                userType,
                                                                objLocationBase.task_id,
                                                                LOCAL_CONSTANT.NAVI.DONATION,
                                                                "visibility_factor_sign_post3"
                                                            )
                                                            : donationReadOnlyObj.visibility_factor_sign_post3,
                                                        objRrBranchLog,
                                                        objRequestErrorList,
                                                        listDeficiencyComment,
                                                        "visibility_factor_sign_post3",
                                                        objDonation.visibility_factor_sign_post3
                                                    )}
                                                    disabled={
                                                        userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                            ? setPermissionFunc(
                                                                userType,
                                                                objLocationBase.task_id,
                                                                LOCAL_CONSTANT.NAVI.DONATION,
                                                                "visibility_factor_sign_post3"
                                                            )
                                                            : donationReadOnlyObj.visibility_factor_sign_post3
                                                    }
                                                >
                                                    {visibilityFactorSignPostList?.map(
                                                        (row: any) => (
                                                            <MenuItem key={row.code_value} value={row.code_value}>
                                                                {row.code_display}
                                                            </MenuItem>
                                                        )
                                                    )}
                                                </Select>
                                            </FormControl>
                                        )}
                                        {/* RFCの場合、不備コメント 吹き出しアイコンを表示 */}
                                        {/* RRの場合、不備コメント 吹き出しと編集アイコンを表示 */}
                                        {LOCAL_CONSTANT.USER_TYPE.RFC_RR.includes(userType) && (
                                            <Grid sx={{ display: "flex" }}>
                                                <IconButton
                                                    disabled={setPermissionFunc(
                                                        userType,
                                                        objLocationBase.task_id,
                                                        LOCAL_CONSTANT.NAVI.DONATION,
                                                        "visibility_factor_sign_post3"
                                                    )}
                                                    onClick={() => {handleChatBubbleClick("visibility_factor_sign_post3");}}
                                                    sx={iconHover}
                                                >
                                                    <Box
                                                        sx={chatBubbleErrorSx(
                                                            userType,
                                                            objLocationBase.task_id,
                                                            LOCAL_CONSTANT.NAVI.DONATION,
                                                            "visibility_factor_sign_post3",
                                                            listDeficiencyComment
                                                        )}
                                                    >
                                                        <ChatBubbleIcon sx={chatBubbleIconSx}/>
                                                    </Box>
                                                </IconButton>
                                                {userType === LOCAL_CONSTANT.USER_TYPE.RR && (
                                                    <IconButton
                                                        onClick={() => {handleEditIconClick("visibility_factor_sign_post3");}}
                                                        sx={iconHover}
                                                    >
                                                        <Box sx={editIconCircleSx}><EditIcon /></Box>
                                                    </IconButton>
                                                )}
                                            </Grid>
                                        )}
                                    </Box>
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    <Box sx={{ display: "flex" }}>
                                        {isBackstreet === true && (
                                            <FormControl fullWidth>
                                                <Select
                                                    onChange={(e) => handleSelectChange(e, "visibility_factor_sign_post4")}
                                                    value={objDonation.visibility_factor_sign_post4}
                                                    sx={inactiveSelectStyle}
                                                    disabled={true}
                                                >
                                                    {visibilityFactorSignPostList?.map(
                                                        (row: any) => (
                                                            <MenuItem key={row.code_value} value={row.code_value}>
                                                                {row.code_display}
                                                            </MenuItem>
                                                        )
                                                    )}
                                                </Select>
                                            </FormControl>
                                        )}
                                        {isBackstreet === false && (
                                            <FormControl fullWidth>
                                                <Select
                                                    onChange={(e) => handleSelectChange(e, "visibility_factor_sign_post4")}
                                                    value={objDonation.visibility_factor_sign_post4}
                                                    sx={selectStyle(
                                                        userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                            ? setPermissionFunc(
                                                                userType,
                                                                objLocationBase.task_id,
                                                                LOCAL_CONSTANT.NAVI.DONATION,
                                                                "visibility_factor_sign_post4"
                                                            )
                                                            : donationReadOnlyObj.visibility_factor_sign_post4,
                                                        objRrBranchLog,
                                                        objRequestErrorList,
                                                        listDeficiencyComment,
                                                        "visibility_factor_sign_post4",
                                                        objDonation.visibility_factor_sign_post4
                                                    )}
                                                    disabled={
                                                        userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                            ? setPermissionFunc(
                                                                userType,
                                                                objLocationBase.task_id,
                                                                LOCAL_CONSTANT.NAVI.DONATION,
                                                                "visibility_factor_sign_post4"
                                                            )
                                                            : donationReadOnlyObj.visibility_factor_sign_post4
                                                    }
                                                >
                                                    {visibilityFactorSignPostList?.map(
                                                        (row: any) => (
                                                            <MenuItem key={row.code_value} value={row.code_value}>
                                                                {row.code_display}
                                                            </MenuItem>
                                                        )
                                                    )}
                                                </Select>
                                            </FormControl>
                                        )}
                                        {/* RFCの場合、不備コメント 吹き出しアイコンを表示 */}
                                        {/* RRの場合、不備コメント 吹き出しと編集アイコンを表示 */}
                                        {LOCAL_CONSTANT.USER_TYPE.RFC_RR.includes(userType) && (
                                            <Grid sx={{ display: "flex" }}>
                                                <IconButton
                                                    disabled={setPermissionFunc(
                                                        userType,
                                                        objLocationBase.task_id,
                                                        LOCAL_CONSTANT.NAVI.DONATION,
                                                        "visibility_factor_sign_post4"
                                                    )}
                                                    onClick={() => {handleChatBubbleClick("visibility_factor_sign_post4");}}
                                                    sx={iconHover}
                                                >
                                                    <Box
                                                        sx={chatBubbleErrorSx(
                                                            userType,
                                                            objLocationBase.task_id,
                                                            LOCAL_CONSTANT.NAVI.DONATION,
                                                            "visibility_factor_sign_post4",
                                                            listDeficiencyComment
                                                        )}
                                                    >
                                                        <ChatBubbleIcon sx={chatBubbleIconSx}/>
                                                    </Box>
                                                </IconButton>
                                                {userType === LOCAL_CONSTANT.USER_TYPE.RR && (
                                                    <IconButton
                                                        onClick={() => {handleEditIconClick("visibility_factor_sign_post4");}}
                                                        sx={iconHover}
                                                    >
                                                        <Box sx={editIconCircleSx}><EditIcon /></Box>
                                                    </IconButton>
                                                )}
                                            </Grid>
                                        )}
                                    </Box>
                                </TableCell>
                            </TableRow>

                            {/* 有効駐車場面積 */}
                            <TableRow>
                                <TableCell sx={cellLabelStyle}>
                                    <Grid container rowSpacing={2}>
                                        <Grid item xs={12}>
                                            <InputLabel sx={titleLabelStyle}>有効駐車場面積</InputLabel>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <InputLabel sx={descriptionLabelStyle}>歩道部分除く</InputLabel>
                                        </Grid>
                                    </Grid>
                                </TableCell>
                                <TableCell sx={cellLabelStyle}>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            width: "70px",
                                        }}
                                    >
                                        <InputLabel>面積</InputLabel>
                                        <RedAsterisk>＊</RedAsterisk>
                                    </Box>
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    <InputWithIcons
                                        props={{
                                            userType: userType, //ユーザー
                                            disabled: setPermissionFunc(
                                                userType,
                                                objLocationBase.task_id,
                                                LOCAL_CONSTANT.NAVI.DONATION,
                                                "parking_area"
                                            ), //ユーザー権限
                                            pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                            labelName: "parking_area",
                                            startAdornment: "",
                                            endAdornment: LOCAL_CONSTANT.LABEL.SQUARE_METER,
                                            InputValueObj: donation,
                                            ReadOnlyObj: donationReadOnlyObj,
                                            setReadOnlyObj: setDonationReadOnlyObj,
                                            ShowEditIconObj: initDonationShowEditIconObj,
                                            ShowIconsObj: donationShowIconsObj,
                                            handleChatBubbleClick: handleChatBubbleClick,
                                            handleInputBlur: handleInputBlur,
                                            handleInputChange: handleIntOrDecimalInputChange,
                                            handleInputClick: handleInputClick,
                                        }}
                                    />
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    <TextField
                                        fullWidth
                                        disabled={true}
                                        value={
                                            objDonation.parking_area === ""
                                                ? ""
                                                : (Math.round(Number(objDonation.parking_area) * 0.3025 * 1000) / 1000).toFixed(2)
                                        }
                                        sx={inactiveTextSx(
                                            userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                ? setPermissionFunc(
                                                    userType,
                                                    objLocationBase.task_id,
                                                    LOCAL_CONSTANT.NAVI.DONATION,
                                                    "parking_area"
                                                )
                                                : donationReadOnlyObj.median_strip_select,
                                            objRrBranchLog,
                                            "parking_area"
                                        )}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start"></InputAdornment>
                                            ),
                                            endAdornment: (
                                                <InputAdornment position="end">坪</InputAdornment>
                                            ),
                                        }}
                                        variant="filled"
                                    />
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    <InputLabel sx={{ textAlign: "center" }}>駐車可能台数</InputLabel>
                                </TableCell>
                                <TableCell sx={tableCell}>
                                    <InputWithIcons
                                        props={{
                                            userType: userType, //ユーザー
                                            disabled: setPermissionFunc(
                                                userType,
                                                objLocationBase.task_id,
                                                LOCAL_CONSTANT.NAVI.DONATION,
                                                "parking_capacity"
                                            ), //ユーザー権限
                                            pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                            labelName: "parking_capacity",
                                            startAdornment: "",
                                            endAdornment: "台",
                                            InputValueObj: donation,
                                            ReadOnlyObj: donationReadOnlyObj,
                                            setReadOnlyObj: setDonationReadOnlyObj,
                                            ShowEditIconObj: initDonationShowEditIconObj,
                                            ShowIconsObj: donationShowIconsObj,
                                            handleChatBubbleClick: handleChatBubbleClick,
                                            handleInputBlur: handleInputBlur,
                                            handleInputChange: handleIntOrDecimalInputChange,
                                            handleInputClick: handleInputClick,
                                        }}
                                    />
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </Grid>
            </Grid>

            <Grid container spacing={1} maxWidth="lg">
                <Grid item xs={12}>
                    <TableContainer>
                        <Table sx={table}>
                            <TableBody>
                                <TableRow>
                                    <TableCell sx={tableHeaderLabelCell}></TableCell>
                                    <TableCell sx={tableHeaderLabelCell}></TableCell>
                                    <TableCell sx={tableHeaderCell}>
                                        <InputLabel>{LOCAL_CONSTANT.LABEL.FRONT}</InputLabel>
                                    </TableCell>
                                    <TableCell sx={tableHeaderCell}>
                                        <InputLabel>{LOCAL_CONSTANT.LABEL.SIDE_A}</InputLabel>
                                    </TableCell>
                                    <TableCell sx={tableHeaderCell}>
                                        <InputLabel>{LOCAL_CONSTANT.LABEL.SIDE_B}   </InputLabel>
                                    </TableCell>
                                    <TableCell sx={tableHeaderCell}>
                                        <InputLabel>{LOCAL_CONSTANT.LABEL.BACK}</InputLabel>
                                    </TableCell>
                                </TableRow>

                                {/* 駐車場接線 */}
                                <TableRow sx={bottomCellLabelStyle}>
                                    <TableCell sx={cellLabelStyle}>
                                        <Grid container rowSpacing={2}>
                                            <Grid item xs={12}>
                                                <InputLabel sx={titleLabelStyle}>駐車場接線</InputLabel>
                                            </Grid>
                                        </Grid>
                                    </TableCell>
                                    <TableCell sx={cellLabelStyle}>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                width: "70px",
                                            }}
                                        >
                                            <InputLabel></InputLabel>
                                            <RedAsterisk>＊</RedAsterisk>
                                        </Box>
                                    </TableCell>
                                    <TableCell sx={tableCell}>
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: setPermissionFunc(
                                                    userType,
                                                    objLocationBase.task_id,
                                                    LOCAL_CONSTANT.NAVI.DONATION,
                                                    "parking_tangent_line_frontage"
                                                ), //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "parking_tangent_line_frontage",
                                                startAdornment: "",
                                                endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    </TableCell>
                                    <TableCell sx={tableCell}>
                                        {isSideWayA === true && (
                                            <InputWithIcons
                                                props={{
                                                    userType: userType, //ユーザー
                                                    disabled: true, //ユーザー権限
                                                    pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                    labelName: "parking_tangent_line_sideway_a",
                                                    startAdornment: "",
                                                    endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                    InputValueObj: donation,
                                                    ReadOnlyObj: donationReadOnlyObj,
                                                    setReadOnlyObj: setDonationReadOnlyObj,
                                                    ShowEditIconObj: initDonationShowEditIconObj,
                                                    ShowIconsObj: donationShowIconsObj,
                                                    handleChatBubbleClick: handleChatBubbleClick,
                                                    handleInputBlur:handleInputBlur,
                                                    handleInputChange: handleIntOrDecimalInputChange,
                                                    handleInputClick: handleInputClick,
                                                }}
                                            />
                                        )}
                                        {isSideWayA === false && (
                                            <InputWithIcons
                                                props={{
                                                    userType: userType, //ユーザー
                                                    disabled: setPermissionFunc(
                                                        userType,
                                                        objLocationBase.task_id,
                                                        LOCAL_CONSTANT.NAVI.DONATION,
                                                        "parking_tangent_line_sideway_a"
                                                    ), //ユーザー権限
                                                    pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                    labelName: "parking_tangent_line_sideway_a",
                                                    startAdornment: "",
                                                    endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                    InputValueObj: donation,
                                                    ReadOnlyObj: donationReadOnlyObj,
                                                    setReadOnlyObj: setDonationReadOnlyObj,
                                                    ShowEditIconObj: initDonationShowEditIconObj,
                                                    ShowIconsObj: donationShowIconsObj,
                                                    handleChatBubbleClick: handleChatBubbleClick,
                                                    handleInputBlur: handleInputBlur,
                                                    handleInputChange: handleIntOrDecimalInputChange,
                                                    handleInputClick: handleInputClick,
                                                }}
                                            />
                                        )}
                                    </TableCell>
                                    <TableCell sx={tableCell}>
                                        {isSideWayB === true && (
                                            <InputWithIcons
                                                props={{
                                                    userType: userType, //ユーザー
                                                    disabled: true, //ユーザー権限
                                                    pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                    labelName: "parking_tangent_line_sideway_b",
                                                    startAdornment: "",
                                                    endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                    InputValueObj: donation,
                                                    ReadOnlyObj: donationReadOnlyObj,
                                                    setReadOnlyObj: setDonationReadOnlyObj,
                                                    ShowEditIconObj: initDonationShowEditIconObj,
                                                    ShowIconsObj: donationShowIconsObj,
                                                    handleChatBubbleClick: handleChatBubbleClick,
                                                    handleInputBlur: handleInputBlur,
                                                    handleInputChange: handleIntOrDecimalInputChange,
                                                    handleInputClick: handleInputClick,
                                                }}
                                            />
                                        )}
                                        {isSideWayB === false && (
                                            <InputWithIcons
                                                props={{
                                                    userType: userType, //ユーザー
                                                    disabled: setPermissionFunc(
                                                        userType,
                                                        objLocationBase.task_id,
                                                        LOCAL_CONSTANT.NAVI.DONATION,
                                                        "parking_tangent_line_sideway_b"
                                                    ), //ユーザー権限
                                                    pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                    labelName: "parking_tangent_line_sideway_b",
                                                    startAdornment: "",
                                                    endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                    InputValueObj: donation,
                                                    ReadOnlyObj: donationReadOnlyObj,
                                                    setReadOnlyObj: setDonationReadOnlyObj,
                                                    ShowEditIconObj: initDonationShowEditIconObj,
                                                    ShowIconsObj: donationShowIconsObj,
                                                    handleChatBubbleClick: handleChatBubbleClick,
                                                    handleInputBlur: handleInputBlur,
                                                    handleInputChange: handleIntOrDecimalInputChange,
                                                    handleInputClick: handleInputClick,
                                                }}
                                            />
                                        )}
                                    </TableCell>
                                    <TableCell sx={tableCell}>
                                        {isBackstreet === true && (
                                            <InputWithIcons
                                                props={{
                                                    userType: userType, //ユーザー
                                                    disabled: true, //ユーザー権限
                                                    pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                    labelName: "parking_tangent_line_backstreet",
                                                    startAdornment: "",
                                                    endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                    InputValueObj: donation,
                                                    ReadOnlyObj: donationReadOnlyObj,
                                                    setReadOnlyObj: setDonationReadOnlyObj,
                                                    ShowEditIconObj: initDonationShowEditIconObj,
                                                    ShowIconsObj: donationShowIconsObj,
                                                    handleChatBubbleClick: handleChatBubbleClick,
                                                    handleInputBlur: handleInputBlur,
                                                    handleInputChange: handleIntOrDecimalInputChange,
                                                    handleInputClick: handleInputClick,
                                                }}
                                            />
                                        )}
                                        {isBackstreet === false && (
                                            <InputWithIcons
                                                props={{
                                                    userType: userType, //ユーザー
                                                    disabled: setPermissionFunc(
                                                        userType,
                                                        objLocationBase.task_id,
                                                        LOCAL_CONSTANT.NAVI.DONATION,
                                                        "parking_tangent_line_backstreet"
                                                    ), //ユーザー権限
                                                    pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                    labelName: "parking_tangent_line_backstreet",
                                                    startAdornment: "",
                                                    endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                    InputValueObj: donation,
                                                    ReadOnlyObj: donationReadOnlyObj,
                                                    setReadOnlyObj: setDonationReadOnlyObj,
                                                    ShowEditIconObj: initDonationShowEditIconObj,
                                                    ShowIconsObj: donationShowIconsObj,
                                                    handleChatBubbleClick: handleChatBubbleClick,
                                                    handleInputBlur: handleInputBlur,
                                                    handleInputChange: handleIntOrDecimalInputChange,
                                                    handleInputClick: handleInputClick,
                                                }}
                                            />
                                        )}
                                    </TableCell>
                                </TableRow>

                                {/* 出入口No.1 進入口 */}
                                <TableRow>
                                    <TableCell sx={cellLabelStyle} rowSpan={2}>
                                        <Grid container rowSpacing={2}>
                                            <Grid item xs={12}>
                                                <InputLabel sx={titleLabelStyle}>出入口　No.1</InputLabel>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <InputLabel sx={descriptionLabelStyle}>進入口=6m以上</InputLabel>
                                                <InputLabel sx={descriptionLabelStyle}>奥行=ドア前車止めの延長線上迄</InputLabel>
                                                <InputLabel sx={descriptionLabelStyle}>奥行き=25度角（tan=0.466）</InputLabel>
                                            </Grid>
                                        </Grid>
                                    </TableCell>
                                    <TableCell sx={cellLabelStyle}>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                width: "70px",
                                            }}
                                        >
                                            <InputLabel>進入口</InputLabel>
                                            <RedAsterisk>＊</RedAsterisk>
                                        </Box>
                                    </TableCell>
                                    <TableCell sx={tableCell}>
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: setPermissionFunc(
                                                    userType,
                                                    objLocationBase.task_id,
                                                    LOCAL_CONSTANT.NAVI.DONATION,
                                                    "no1_entrance_frontage"
                                                ), //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "no1_entrance_frontage",
                                                startAdornment: "",
                                                endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,       
                                            }}
                                        />
                                    </TableCell>
                                    <TableCell sx={tableCell}>
                                        {isSideWayA === true && (
                                            <InputWithIcons
                                                props={{
                                                    userType: userType, //ユーザー
                                                    disabled: true, //ユーザー権限
                                                    pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                    labelName: "no1_entrance_sideway_a",
                                                    startAdornment: "",
                                                    endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                    InputValueObj: donation,
                                                    ReadOnlyObj: donationReadOnlyObj,
                                                    setReadOnlyObj: setDonationReadOnlyObj,
                                                    ShowEditIconObj: initDonationShowEditIconObj,
                                                    ShowIconsObj: donationShowIconsObj,
                                                    handleChatBubbleClick: handleChatBubbleClick,
                                                    handleInputBlur: handleInputBlur,
                                                    handleInputChange: handleIntOrDecimalInputChange,
                                                    handleInputClick: handleInputClick,
                                                }}
                                            />
                                        )}
                                        {isSideWayA === false && (
                                            <InputWithIcons
                                                props={{
                                                    userType: userType, //ユーザー
                                                    disabled: setPermissionFunc(
                                                        userType,
                                                        objLocationBase.task_id,
                                                        LOCAL_CONSTANT.NAVI.DONATION,
                                                        "no1_entrance_sideway_a"
                                                    ), //ユーザー権限
                                                    pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                    labelName: "no1_entrance_sideway_a",
                                                    startAdornment: "",
                                                    endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                    InputValueObj: donation,
                                                    ReadOnlyObj: donationReadOnlyObj,
                                                    setReadOnlyObj: setDonationReadOnlyObj,
                                                    ShowEditIconObj: initDonationShowEditIconObj,
                                                    ShowIconsObj: donationShowIconsObj,
                                                    handleChatBubbleClick: handleChatBubbleClick,
                                                    handleInputBlur: handleInputBlur,
                                                    handleInputChange: handleIntOrDecimalInputChange,
                                                    handleInputClick: handleInputClick,
                                                }}
                                            />
                                        )}
                                    </TableCell>
                                    <TableCell sx={tableCell}>
                                        {isSideWayB === true && (
                                            <InputWithIcons
                                                props={{
                                                    userType: userType, //ユーザー
                                                    disabled: true, //ユーザー権限
                                                    pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                    labelName: "no1_entrance_sideway_b",
                                                    startAdornment: "",
                                                    endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                    InputValueObj: donation,
                                                    ReadOnlyObj: donationReadOnlyObj,
                                                    setReadOnlyObj: setDonationReadOnlyObj,
                                                    ShowEditIconObj: initDonationShowEditIconObj,
                                                    ShowIconsObj: donationShowIconsObj,
                                                    handleChatBubbleClick: handleChatBubbleClick,
                                                    handleInputBlur: handleInputBlur,
                                                    handleInputChange: handleIntOrDecimalInputChange,
                                                    handleInputClick: handleInputClick,
                                                }}
                                            />
                                        )}
                                        {isSideWayB === false && (
                                            <InputWithIcons
                                                props={{
                                                    userType: userType, //ユーザー
                                                    disabled: setPermissionFunc(
                                                        userType,
                                                        objLocationBase.task_id,
                                                        LOCAL_CONSTANT.NAVI.DONATION,
                                                        "no1_entrance_sideway_b"
                                                    ), //ユーザー権限
                                                    pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                    labelName: "no1_entrance_sideway_b",
                                                    startAdornment: "",
                                                    endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                    InputValueObj: donation,
                                                    ReadOnlyObj: donationReadOnlyObj,
                                                    setReadOnlyObj: setDonationReadOnlyObj,
                                                    ShowEditIconObj: initDonationShowEditIconObj,
                                                    ShowIconsObj: donationShowIconsObj,
                                                    handleChatBubbleClick: handleChatBubbleClick,
                                                    handleInputBlur: handleInputBlur,
                                                    handleInputChange: handleIntOrDecimalInputChange,
                                                    handleInputClick: handleInputClick,
                                                }}
                                            />
                                        )}
                                    </TableCell>
                                    <TableCell sx={tableCell}>
                                        {isBackstreet === true && (
                                            <InputWithIcons
                                                props={{
                                                    userType: userType, //ユーザー
                                                    disabled: true, //ユーザー権限
                                                    pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                    labelName: "no1_entrance_backstreet",
                                                    startAdornment: "",
                                                    endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                    InputValueObj: donation,
                                                    ReadOnlyObj: donationReadOnlyObj,
                                                    setReadOnlyObj: setDonationReadOnlyObj,
                                                    ShowEditIconObj: initDonationShowEditIconObj,
                                                    ShowIconsObj: donationShowIconsObj,
                                                    handleChatBubbleClick: handleChatBubbleClick,
                                                    handleInputBlur: handleInputBlur,
                                                    handleInputChange: handleIntOrDecimalInputChange,
                                                    handleInputClick: handleInputClick,
                                                }}
                                            />
                                        )}
                                        {isBackstreet === false && (
                                            <InputWithIcons
                                                props={{
                                                    userType: userType, //ユーザー
                                                    disabled: setPermissionFunc(
                                                        userType,
                                                        objLocationBase.task_id,
                                                        LOCAL_CONSTANT.NAVI.DONATION,
                                                        "no1_entrance_backstreet"
                                                    ), //ユーザー権限
                                                    pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                    labelName: "no1_entrance_backstreet",
                                                    startAdornment: "",
                                                    endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                    InputValueObj: donation,
                                                    ReadOnlyObj: donationReadOnlyObj,
                                                    setReadOnlyObj: setDonationReadOnlyObj,
                                                    ShowEditIconObj: initDonationShowEditIconObj,
                                                    ShowIconsObj: donationShowIconsObj,
                                                    handleChatBubbleClick: handleChatBubbleClick,
                                                    handleInputBlur: handleInputBlur,
                                                    handleInputChange: handleIntOrDecimalInputChange,
                                                    handleInputClick: handleInputClick,
                                                }}
                                            />
                                        )}
                                    </TableCell>
                                </TableRow>

                                {/* 出入口No.1 奥行き */}
                                <TableRow sx={bottomCellLabelStyle}>
                                    <TableCell sx={cellLabelStyle}>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                width: "70px",
                                            }}
                                        >
                                            <InputLabel>奥行き</InputLabel>
                                            <RedAsterisk>＊</RedAsterisk>
                                        </Box>
                                    </TableCell>
                                    <TableCell sx={tableCell}>
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: setPermissionFunc(
                                                    userType,
                                                    objLocationBase.task_id,
                                                    LOCAL_CONSTANT.NAVI.DONATION,
                                                    "no1_depth_frontage"
                                                ), //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "no1_depth_frontage",
                                                startAdornment: "",
                                                endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    </TableCell>
                                    <TableCell sx={tableCell}>
                                        {isSideWayA === true && (
                                            <InputWithIcons
                                                props={{
                                                    userType: userType, //ユーザー
                                                    disabled: true, //ユーザー権限
                                                    pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                    labelName: "no1_depth_sideway_a",
                                                    startAdornment: "",
                                                    endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                    InputValueObj: donation,
                                                    ReadOnlyObj: donationReadOnlyObj,
                                                    setReadOnlyObj: setDonationReadOnlyObj,
                                                    ShowEditIconObj: initDonationShowEditIconObj,
                                                    ShowIconsObj: donationShowIconsObj,
                                                    handleChatBubbleClick: handleChatBubbleClick,
                                                    handleInputBlur: handleInputBlur,
                                                    handleInputChange: handleIntOrDecimalInputChange,
                                                    handleInputClick: handleInputClick,
                                                }}
                                            />
                                        )}
                                        {isSideWayA === false && (
                                            <InputWithIcons
                                                props={{
                                                    userType: userType, //ユーザー
                                                    disabled: setPermissionFunc(
                                                        userType,
                                                        objLocationBase.task_id,
                                                        LOCAL_CONSTANT.NAVI.DONATION,
                                                        "no1_depth_sideway_a"
                                                    ), //ユーザー権限
                                                    pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                    labelName: "no1_depth_sideway_a",
                                                    startAdornment: "",
                                                    endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                    InputValueObj: donation,
                                                    ReadOnlyObj: donationReadOnlyObj,
                                                    setReadOnlyObj: setDonationReadOnlyObj,
                                                    ShowEditIconObj: initDonationShowEditIconObj,
                                                    ShowIconsObj: donationShowIconsObj,
                                                    handleChatBubbleClick: handleChatBubbleClick,
                                                    handleInputBlur: handleInputBlur,
                                                    handleInputChange: handleIntOrDecimalInputChange,
                                                    handleInputClick: handleInputClick,
                                                }}
                                            />
                                        )}
                                    </TableCell>
                                    <TableCell sx={tableCell}>
                                        {isSideWayB === true && (
                                            <InputWithIcons
                                                props={{
                                                    userType: userType, //ユーザー
                                                    disabled: true, //ユーザー権限
                                                    pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                    labelName:"no1_depth_sideway_b",
                                                    startAdornment: "",
                                                    endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                    InputValueObj: donation,
                                                    ReadOnlyObj: donationReadOnlyObj,
                                                    setReadOnlyObj: setDonationReadOnlyObj,
                                                    ShowEditIconObj: initDonationShowEditIconObj,
                                                    ShowIconsObj: donationShowIconsObj,
                                                    handleChatBubbleClick: handleChatBubbleClick,
                                                    handleInputBlur: handleInputBlur,
                                                    handleInputChange: handleIntOrDecimalInputChange,
                                                    handleInputClick: handleInputClick,
                                                }}
                                            />
                                        )}
                                        {isSideWayB === false && (
                                            <InputWithIcons
                                                props={{
                                                    userType: userType, //ユーザー
                                                    disabled: setPermissionFunc(
                                                        userType,
                                                        objLocationBase.task_id,
                                                        LOCAL_CONSTANT.NAVI.DONATION,
                                                        "no1_depth_sideway_b"
                                                    ), //ユーザー権限
                                                    pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                    labelName: "no1_depth_sideway_b",
                                                    startAdornment: "",
                                                    endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                    InputValueObj: donation,
                                                    ReadOnlyObj: donationReadOnlyObj,
                                                    setReadOnlyObj: setDonationReadOnlyObj,
                                                    ShowEditIconObj: initDonationShowEditIconObj,
                                                    ShowIconsObj: donationShowIconsObj,
                                                    handleChatBubbleClick: handleChatBubbleClick,
                                                    handleInputBlur: handleInputBlur,
                                                    handleInputChange: handleIntOrDecimalInputChange,
                                                    handleInputClick: handleInputClick,
                                                }}
                                            />
                                        )}
                                    </TableCell>
                                    <TableCell sx={tableCell}>
                                        {isBackstreet === true && (
                                            <InputWithIcons
                                                props={{
                                                    userType: userType, //ユーザー
                                                    disabled: true, //ユーザー権限
                                                    pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                    labelName: "no1_depth_backstreet",
                                                    startAdornment: "",
                                                    endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                    InputValueObj: donation,
                                                    ReadOnlyObj: donationReadOnlyObj,
                                                    setReadOnlyObj: setDonationReadOnlyObj,
                                                    ShowEditIconObj: initDonationShowEditIconObj,
                                                    ShowIconsObj: donationShowIconsObj,
                                                    handleChatBubbleClick: handleChatBubbleClick,
                                                    handleInputBlur: handleInputBlur,
                                                    handleInputChange: handleIntOrDecimalInputChange,
                                                    handleInputClick: handleInputClick,
                                                }}
                                            />
                                        )}
                                        {isBackstreet === false && (
                                            <InputWithIcons
                                                props={{
                                                    userType: userType, //ユーザー
                                                    disabled: setPermissionFunc(
                                                        userType,
                                                        objLocationBase.task_id,
                                                        LOCAL_CONSTANT.NAVI.DONATION,
                                                        "no1_depth_backstreet"
                                                    ), //ユーザー権限
                                                    pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                    labelName: "no1_depth_backstreet",
                                                    startAdornment: "",
                                                    endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                    InputValueObj: donation,
                                                    ReadOnlyObj: donationReadOnlyObj,
                                                    setReadOnlyObj: setDonationReadOnlyObj,
                                                    ShowEditIconObj: initDonationShowEditIconObj,
                                                    ShowIconsObj: donationShowIconsObj,
                                                    handleChatBubbleClick: handleChatBubbleClick,
                                                    handleInputBlur:handleInputBlur,
                                                    handleInputChange: handleIntOrDecimalInputChange,
                                                    handleInputClick: handleInputClick,
                                                }}
                                            />
                                        )}
                                    </TableCell>
                                </TableRow>

                                {/* 出入口No.2 進入口 */}
                                <TableRow>
                                    <TableCell sx={cellLabelStyle} rowSpan={2}>
                                        <Grid container rowSpacing={2}>
                                            <Grid item xs={12}>
                                                <InputLabel sx={titleLabelStyle}>出入口　No.2</InputLabel>
                                            </Grid>
                                        </Grid>
                                    </TableCell>
                                    <TableCell sx={cellLabelStyle}>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                width: "85px",
                                            }}
                                        >
                                            <InputLabel>進入口</InputLabel>
                                            <RedAsterisk>＊</RedAsterisk>
                                        </Box>
                                    </TableCell>
                                    <TableCell sx={tableCell}>
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: setPermissionFunc(
                                                    userType,
                                                    objLocationBase.task_id,
                                                    LOCAL_CONSTANT.NAVI.DONATION,
                                                    "no2_entrance_frontage"
                                                ), //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "no2_entrance_frontage",
                                                startAdornment: "",
                                                endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    </TableCell>
                                    <TableCell sx={tableCell}>
                                        {isSideWayA === true && (
                                            <InputWithIcons
                                                props={{
                                                    userType: userType, //ユーザー
                                                    disabled: true, //ユーザー権限
                                                    pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                    labelName: "no2_entrance_sideway_a",
                                                    startAdornment: "",
                                                    endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                    InputValueObj: donation,
                                                    ReadOnlyObj: donationReadOnlyObj,
                                                    setReadOnlyObj: setDonationReadOnlyObj,
                                                    ShowEditIconObj: initDonationShowEditIconObj,
                                                    ShowIconsObj: donationShowIconsObj,
                                                    handleChatBubbleClick: handleChatBubbleClick,
                                                    handleInputBlur: handleInputBlur,
                                                    handleInputChange: handleIntOrDecimalInputChange,
                                                    handleInputClick: handleInputClick,
                                                }}
                                            />
                                        )}
                                        {isSideWayA === false && (
                                            <InputWithIcons
                                                props={{
                                                    userType: userType, //ユーザー
                                                    disabled: setPermissionFunc(
                                                        userType,
                                                        objLocationBase.task_id,
                                                        LOCAL_CONSTANT.NAVI.DONATION,
                                                        "no2_entrance_sideway_a"
                                                    ), //ユーザー権限
                                                    pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                    labelName: "no2_entrance_sideway_a",
                                                    startAdornment: "",
                                                    endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                    InputValueObj: donation,
                                                    ReadOnlyObj: donationReadOnlyObj,
                                                    setReadOnlyObj: setDonationReadOnlyObj,
                                                    ShowEditIconObj: initDonationShowEditIconObj,
                                                    ShowIconsObj: donationShowIconsObj,
                                                    handleChatBubbleClick: handleChatBubbleClick,
                                                    handleInputBlur: handleInputBlur,
                                                    handleInputChange: handleIntOrDecimalInputChange,
                                                    handleInputClick: handleInputClick,
                                                }}
                                            />
                                        )}
                                    </TableCell>
                                    <TableCell sx={tableCell}>
                                        {isSideWayB === true && (
                                            <InputWithIcons
                                                props={{
                                                    userType: userType, //ユーザー
                                                    disabled: true, //ユーザー権限
                                                    pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                    labelName: "no2_entrance_sideway_b",
                                                    startAdornment: "",
                                                    endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                    InputValueObj: donation,
                                                    ReadOnlyObj: donationReadOnlyObj,
                                                    setReadOnlyObj: setDonationReadOnlyObj,
                                                    ShowEditIconObj: initDonationShowEditIconObj,
                                                    ShowIconsObj: donationShowIconsObj,
                                                    handleChatBubbleClick: handleChatBubbleClick,
                                                    handleInputBlur: handleInputBlur,
                                                    handleInputChange: handleIntOrDecimalInputChange,
                                                    handleInputClick: handleInputClick,
                                                }}
                                            />
                                        )}
                                        {isSideWayB === false && (
                                            <InputWithIcons
                                                props={{
                                                    userType: userType, //ユーザー
                                                    disabled: setPermissionFunc(
                                                        userType,
                                                        objLocationBase.task_id,
                                                        LOCAL_CONSTANT.NAVI.DONATION,
                                                        "no2_entrance_sideway_b"
                                                    ), //ユーザー権限
                                                    pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                    labelName: "no2_entrance_sideway_b",
                                                    startAdornment: "",
                                                    endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                    InputValueObj: donation,
                                                    ReadOnlyObj: donationReadOnlyObj,
                                                    setReadOnlyObj: setDonationReadOnlyObj,
                                                    ShowEditIconObj: initDonationShowEditIconObj,
                                                    ShowIconsObj: donationShowIconsObj,
                                                    handleChatBubbleClick: handleChatBubbleClick,
                                                    handleInputBlur: handleInputBlur,
                                                    handleInputChange: handleIntOrDecimalInputChange,
                                                    handleInputClick:handleInputClick,
                                                }}
                                            />
                                        )}
                                    </TableCell>
                                    <TableCell sx={tableCell}>
                                        {isBackstreet === true && (
                                            <InputWithIcons
                                                props={{
                                                    userType: userType, //ユーザー
                                                    disabled: true, //ユーザー権限
                                                    pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                    labelName: "no2_entrance_backstreet",
                                                    startAdornment: "",
                                                    endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                    InputValueObj: donation,
                                                    ReadOnlyObj: donationReadOnlyObj,
                                                    setReadOnlyObj: setDonationReadOnlyObj,
                                                    ShowEditIconObj: initDonationShowEditIconObj,
                                                    ShowIconsObj: donationShowIconsObj,
                                                    handleChatBubbleClick: handleChatBubbleClick,
                                                    handleInputBlur: handleInputBlur,
                                                    handleInputChange: handleIntOrDecimalInputChange,
                                                    handleInputClick: handleInputClick,
                                                }}
                                            />
                                        )}
                                        {isBackstreet === false && (
                                            <InputWithIcons
                                                props={{
                                                    userType: userType, //ユーザー
                                                    disabled: setPermissionFunc(
                                                        userType,
                                                        objLocationBase.task_id,
                                                        LOCAL_CONSTANT.NAVI.DONATION,
                                                        "no2_entrance_backstreet"
                                                    ), //ユーザー権限
                                                    pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                    labelName: "no2_entrance_backstreet",
                                                    startAdornment: "",
                                                    endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                    InputValueObj: donation,
                                                    ReadOnlyObj: donationReadOnlyObj,
                                                    setReadOnlyObj: setDonationReadOnlyObj,
                                                    ShowEditIconObj: initDonationShowEditIconObj,
                                                    ShowIconsObj: donationShowIconsObj,
                                                    handleChatBubbleClick: handleChatBubbleClick,
                                                    handleInputBlur: handleInputBlur,
                                                    handleInputChange: handleIntOrDecimalInputChange,
                                                    handleInputClick: handleInputClick,
                                                }}
                                            />
                                        )}
                                    </TableCell>
                                </TableRow>

                                {/* 出入口No.2 奥行き */}
                                <TableRow>
                                    <TableCell sx={cellLabelStyle}>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                width: "85px",
                                            }}
                                        >
                                            <InputLabel>奥行き</InputLabel>
                                            <RedAsterisk>＊</RedAsterisk>
                                        </Box>
                                    </TableCell>
                                    <TableCell sx={tableCell}>
                                        <InputWithIcons
                                            props={{
                                                userType: userType, //ユーザー
                                                disabled: setPermissionFunc(
                                                    userType,
                                                    objLocationBase.task_id,
                                                    LOCAL_CONSTANT.NAVI.DONATION,
                                                    "no2_depth_frontage"
                                                ), //ユーザー権限
                                                pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                labelName: "no2_depth_frontage",
                                                startAdornment: "",
                                                endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                InputValueObj: donation,
                                                ReadOnlyObj: donationReadOnlyObj,
                                                setReadOnlyObj: setDonationReadOnlyObj,
                                                ShowEditIconObj: initDonationShowEditIconObj,
                                                ShowIconsObj: donationShowIconsObj,
                                                handleChatBubbleClick: handleChatBubbleClick,
                                                handleInputBlur: handleInputBlur,
                                                handleInputChange: handleIntOrDecimalInputChange,
                                                handleInputClick: handleInputClick,
                                            }}
                                        />
                                    </TableCell>
                                    <TableCell sx={tableCell}>
                                        {isSideWayA === true && (
                                            <InputWithIcons
                                                props={{
                                                    userType: userType, //ユーザー
                                                    disabled: true, //ユーザー権限
                                                    pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                    labelName: "no2_depth_sideway_a",
                                                    startAdornment: "",
                                                    endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                    InputValueObj: donation,
                                                    ReadOnlyObj: donationReadOnlyObj,
                                                    setReadOnlyObj: setDonationReadOnlyObj,
                                                    ShowEditIconObj: initDonationShowEditIconObj,
                                                    ShowIconsObj: donationShowIconsObj,
                                                    handleChatBubbleClick: handleChatBubbleClick,
                                                    handleInputBlur: handleInputBlur,
                                                    handleInputChange: handleIntOrDecimalInputChange,
                                                    handleInputClick: handleInputClick,
                                                }}
                                            />
                                        )}
                                        {isSideWayA === false && (
                                            <InputWithIcons
                                                props={{
                                                    userType: userType, //ユーザー
                                                    disabled: setPermissionFunc(
                                                        userType,
                                                        objLocationBase.task_id,
                                                        LOCAL_CONSTANT.NAVI.DONATION,
                                                        "no2_depth_sideway_a"
                                                    ), //ユーザー権限
                                                    pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                    labelName: "no2_depth_sideway_a",
                                                    startAdornment: "",
                                                    endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                    InputValueObj: donation,
                                                    ReadOnlyObj: donationReadOnlyObj,
                                                    setReadOnlyObj: setDonationReadOnlyObj,
                                                    ShowEditIconObj: initDonationShowEditIconObj,
                                                    ShowIconsObj: donationShowIconsObj,
                                                    handleChatBubbleClick: handleChatBubbleClick,
                                                    handleInputBlur: handleInputBlur,
                                                    handleInputChange: handleIntOrDecimalInputChange,
                                                    handleInputClick: handleInputClick,
                                                }}
                                            />
                                        )}
                                    </TableCell>
                                    <TableCell sx={tableCell}>
                                        {isSideWayB === true && (
                                            <InputWithIcons
                                                props={{
                                                    userType: userType, //ユーザー
                                                    disabled: true, //ユーザー権限
                                                    pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                    labelName: "no2_depth_sideway_b",
                                                    startAdornment: "",
                                                    endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                    InputValueObj: donation,
                                                    ReadOnlyObj: donationReadOnlyObj,
                                                    setReadOnlyObj: setDonationReadOnlyObj,
                                                    ShowEditIconObj: initDonationShowEditIconObj,
                                                    ShowIconsObj: donationShowIconsObj,
                                                    handleChatBubbleClick: handleChatBubbleClick,
                                                    handleInputBlur: handleInputBlur,
                                                    handleInputChange: handleIntOrDecimalInputChange,
                                                    handleInputClick: handleInputClick,
                                                }}
                                            />
                                        )}
                                        {isSideWayB === false && (
                                            <InputWithIcons
                                                props={{
                                                    userType: userType, //ユーザー
                                                    disabled: setPermissionFunc(
                                                        userType,
                                                        objLocationBase.task_id,
                                                        LOCAL_CONSTANT.NAVI.DONATION,
                                                        "no2_depth_sideway_b"
                                                    ), //ユーザー権限
                                                    pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                    labelName: "no2_depth_sideway_b",
                                                    startAdornment: "",
                                                    endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                    InputValueObj: donation,
                                                    ReadOnlyObj: donationReadOnlyObj,
                                                    setReadOnlyObj: setDonationReadOnlyObj,
                                                    ShowEditIconObj: initDonationShowEditIconObj,
                                                    ShowIconsObj: donationShowIconsObj,
                                                    handleChatBubbleClick: handleChatBubbleClick,
                                                    handleInputBlur: handleInputBlur,
                                                    handleInputChange: handleIntOrDecimalInputChange,
                                                    handleInputClick: handleInputClick,
                                                }}
                                            />
                                        )}
                                    </TableCell>
                                    <TableCell sx={tableCell}>
                                        {isBackstreet === true && (
                                            <InputWithIcons
                                                props={{
                                                    userType: userType, //ユーザー
                                                    disabled: true, //ユーザー権限
                                                    pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                    labelName: "no2_depth_backstreet",
                                                    startAdornment: "",
                                                    endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                    InputValueObj: donation,
                                                    ReadOnlyObj: donationReadOnlyObj,
                                                    setReadOnlyObj: setDonationReadOnlyObj,
                                                    ShowEditIconObj: initDonationShowEditIconObj,
                                                    ShowIconsObj: donationShowIconsObj,
                                                    handleChatBubbleClick: handleChatBubbleClick,
                                                    handleInputBlur: handleInputBlur,
                                                    handleInputChange: handleIntOrDecimalInputChange,
                                                    handleInputClick: handleInputClick,
                                                }}
                                            />
                                        )}
                                        {isBackstreet === false && (
                                            <InputWithIcons
                                                props={{
                                                    userType: userType, //ユーザー
                                                    disabled: setPermissionFunc(
                                                        userType,
                                                        objLocationBase.task_id,
                                                        LOCAL_CONSTANT.NAVI.DONATION,
                                                        "no2_depth_backstreet"
                                                    ), //ユーザー権限
                                                    pageName: LOCAL_CONSTANT.NAVI.DONATION,
                                                    labelName: "no2_depth_backstreet",
                                                    startAdornment: "",
                                                    endAdornment: LOCAL_CONSTANT.LABEL.METER,
                                                    InputValueObj: donation,
                                                    ReadOnlyObj: donationReadOnlyObj,
                                                    setReadOnlyObj: setDonationReadOnlyObj,
                                                    ShowEditIconObj: initDonationShowEditIconObj,
                                                    ShowIconsObj: donationShowIconsObj,
                                                    handleChatBubbleClick: handleChatBubbleClick,
                                                    handleInputBlur: handleInputBlur,
                                                    handleInputChange: handleIntOrDecimalInputChange,
                                                    handleInputClick: handleInputClick,
                                                }}
                                            />
                                        )}
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>

            {/* ※検討中　未開通道路・開拓地の場合 */}
            <Grid container spacing={2} maxWidth="lg">
                <Grid item xs={8}>
                    <TableContainer>
                        <Table sx={table}>
                            <TableBody>
                                <TableRow>
                                    <TableCell sx={cellLabelStyle}>
                                        <InputLabel>※未開通道路・開拓地の場合</InputLabel>
                                    </TableCell>
                                    <TableCell sx={tableCell}>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                width: "110px",
                                            }}
                                        >
                                            <InputLabel sx={{ width: "75px" }}>完了予定</InputLabel>
                                            <RedAsterisk>＊＊</RedAsterisk>
                                        </Box>
                                    </TableCell>
                                    <TableCell sx={tableCell}>
                                        <FormControl fullWidth>
                                            <InputLabel id="complete-schedule-year-label">年</InputLabel>
                                            {/* 不備コメントの項目名と異なるため、コメントで登録した場合は赤枠囲まれない  complete_schedule_yearとcomplete_schedule*/}
                                            <Select
                                                labelId="complete-schedule-year-label"
                                                onChange={(e) => handleYearMonthSelectChange(e, "complete_schedule_year")}
                                                value={objDonation.complete_schedule_year}
                                                input={<OutlinedInput label="年" />}
                                                sx={selectStyle(
                                                    userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                        ? setPermissionFunc(
                                                            userType,
                                                            objLocationBase.task_id,
                                                            LOCAL_CONSTANT.NAVI.DONATION,
                                                            "complete_schedule_year"
                                                        )
                                                        : donationReadOnlyObj.complete_schedule,
                                                    objRrBranchLog,
                                                    objRequestErrorList,
                                                    listDeficiencyComment,
                                                    "complete_schedule_year",
                                                    objDonation.complete_schedule_year
                                                )}
                                                disabled={
                                                    userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                        ? setPermissionFunc(
                                                            userType,
                                                            objLocationBase.task_id,
                                                            LOCAL_CONSTANT.NAVI.DONATION,
                                                            "complete_schedule_year"
                                                        )
                                                        : donationReadOnlyObj.complete_schedule
                                                }
                                            >
                                                {Array(27)
                                                    .fill(2024)
                                                    .map((val, i) => {
                                                        return (
                                                            <MenuItem key={i} value={`${val + i}年`}>
                                                                {`${val + i} 年`}
                                                            </MenuItem>
                                                        );
                                                    })}
                                                <MenuItem value="">　</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </TableCell>
                                    <TableCell sx={tableCell}>
                                        <FormControl fullWidth>
                                            <InputLabel id="complete-schedule-month-label">月</InputLabel>
                                            {/* 不備コメントの項目名と異なるため、コメントで登録した場合は赤枠囲まれない  complete_schedule_monthとcomplete_schedule*/}
                                            <Select
                                                labelId="complete-schedule-month-label"
                                                onChange={(e) => handleYearMonthSelectChange(e, "complete_schedule_month")}
                                                value={objDonation.complete_schedule_month}
                                                input={<OutlinedInput label="月" />}
                                                sx={selectStyle(
                                                    userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                        ? setPermissionFunc(
                                                            userType,
                                                            objLocationBase.task_id,
                                                            LOCAL_CONSTANT.NAVI.DONATION,
                                                            "complete_schedule_month"
                                                        )
                                                        : donationReadOnlyObj.complete_schedule,
                                                    objRrBranchLog,
                                                    objRequestErrorList,
                                                    listDeficiencyComment,
                                                    "complete_schedule_month",
                                                    objDonation.complete_schedule_month
                                                )}
                                                disabled={
                                                    userType === LOCAL_CONSTANT.USER_TYPE.RFC
                                                        ? setPermissionFunc(
                                                            userType,
                                                            objLocationBase.task_id,
                                                            LOCAL_CONSTANT.NAVI.DONATION,
                                                            "complete_schedule_month"
                                                        )
                                                        : donationReadOnlyObj.complete_schedule
                                                }
                                            >
                                                {Array(12)
                                                    .fill(1)
                                                    .map((val, i) => {
                                                        return (
                                                            <MenuItem key={i} value={`${val + i}月`}>
                                                                {`${val + i} 月頃`}
                                                            </MenuItem>
                                                        );
                                                    })}
                                                <MenuItem value="">　</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </TableCell>
                                    <TableCell sx={tableCell}>
                                        <Box sx={{ display: "flex" }}>
                                            {/* RFCの場合、不備コメント 吹き出しアイコンを表示 */}
                                            {/* RRの場合、不備コメント 吹き出しと編集アイコンを表示 */}
                                            {LOCAL_CONSTANT.USER_TYPE.RFC_RR.includes(userType) && (
                                                <Grid sx={{ display: "flex" }}>
                                                    <IconButton
                                                        disabled={setPermissionFunc(
                                                            userType,
                                                            objLocationBase.task_id,
                                                            LOCAL_CONSTANT.NAVI.DONATION,
                                                            "complete_schedule"
                                                        )}
                                                        onClick={() => {handleChatBubbleClick("complete_schedule");}}
                                                        sx={iconHover}
                                                    >
                                                        <Box
                                                            sx={chatBubbleErrorSx(
                                                                userType,
                                                                objLocationBase.task_id,
                                                                LOCAL_CONSTANT.NAVI.DONATION,
                                                                "complete_schedule",
                                                                listDeficiencyComment
                                                            )}
                                                        >
                                                            <ChatBubbleIcon sx={chatBubbleIconSx}/>
                                                        </Box>
                                                    </IconButton>
                                                    {userType === LOCAL_CONSTANT.USER_TYPE.RR && (
                                                        <IconButton
                                                            onClick={() => {handleEditIconClick("complete_schedule");}}
                                                            sx={iconHover}
                                                        >
                                                            <Box sx={editIconCircleSx}><EditIcon /></Box>
                                                        </IconButton>
                                                    )}
                                                </Grid>
                                            )}
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
                <Grid item xs={4}></Grid>
            </Grid>

            {/*不備コメント モーダル画面 */}
            <DeficiencyCommentRegistModal
                props={{
                    userType: userType,
                    modalOpen: deficiencyComentModalFlag,
                    setModalOpen: setDeficiencyComentModalFlag,
                    CommentTextFieldObj: donationCommentTextFieldObj,
                    tableName: LOCAL_CONSTANT.TABLE.DONATION,
                    columnName: labelNameStr,
                    subKey: LOCAL_CONSTANT.DEFICIENCY.DEFAULT_SUB_KEY,
                    handleCommentChange: handleCommentChange,
                    handleSaveComment: handleSaveComment,
                }}
            />
        </div>
    );
};

export default Donation;
